(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[6],{

/***/ "/QYh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__("O5Wi");

var _classCallCheck = __webpack_require__("zQIG");

var _createClass = __webpack_require__("8mBC");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _useSubscription = __webpack_require__("D3Vl");

var _loadableContext = __webpack_require__("4smK");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
@copyright (c) 2017-present James Kyle <me@thejameskyle.com>
MIT License
Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:
The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE
*/
// https://github.com/jamiebuilds/react-loadable/blob/v5.5.0/src/index.js
// Modified to be compatible with webpack 4 / Next.js


var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };
  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);
      result.promise.then(function (res) {
        state.loaded[key] = res;
      })["catch"](function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    state.error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  })["catch"](function (err) {
    state.loading = false;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function render(loaded, props) {
  return /*#__PURE__*/_react["default"].createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render,
    webpack: null,
    modules: null
  }, options);
  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true && typeof opts.webpack === 'function') {
    var moduleIds = opts.webpack();
    READY_INITIALIZERS.push(function (ids) {
      var _iterator = _createForOfIteratorHelper(moduleIds),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var moduleId = _step.value;

          if (ids.indexOf(moduleId) !== -1) {
            return init();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  }

  var LoadableComponent = function LoadableComponent(props, ref) {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    var state = (0, _useSubscription.useSubscription)(subscription);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return /*#__PURE__*/_react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return opts.render(state.loaded, props);
      } else {
        return null;
      }
    }, [props, state]);
  };

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return /*#__PURE__*/_react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _objectSpread(_objectSpread({}, this._state), {}, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== 'function') {
    throw new Error('LoadableMap requires a `render(loaded, props)` function');
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ "2prg":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/zloirock/core-js/issues/280
var userAgent = __webpack_require__("ZORK");

// eslint-disable-next-line unicorn/no-unsafe-regex -- safe
module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);


/***/ }),

/***/ "4smK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.LoadableContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LoadableContext = /*#__PURE__*/_react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ "AU4o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__("O5Wi");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.noSSR = noSSR;
exports["default"] = dynamic;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _loadable = _interopRequireDefault(__webpack_require__("/QYh"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
} // function dynamic<P = {}, O extends DynamicOptions>(options: O):


function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), options);

  if (typeof dynamicOptions === 'object' && !(dynamicOptions instanceof Promise)) {
    // show deprecation warning for `modules` key in development
    if (false) {} // Support for `render` when using a mapping, eg: `dynamic({ modules: () => {return {HelloWorld: import('../hello-world')}, render(props, loaded) {} } })


    if (dynamicOptions.render) {
      loadableOptions.render = function (loaded, props) {
        return dynamicOptions.render(props, loaded);
      };
    } // Support for `modules` when using a mapping, eg: `dynamic({ modules: () => {return {HelloWorld: import('../hello-world')}, render(props, loaded) {} } })


    if (dynamicOptions.modules) {
      loadableFn = _loadable["default"].Map;
      var loadModules = {};
      var modules = dynamicOptions.modules();
      Object.keys(modules).forEach(function (key) {
        var value = modules[key];

        if (typeof value.then === 'function') {
          loadModules[key] = function () {
            return value.then(function (mod) {
              return mod["default"] || mod;
            });
          };

          return;
        }

        loadModules[key] = value;
      });
      loadableOptions.loader = loadModules;
    }
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})


  if (typeof loadableOptions.ssr === 'boolean') {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

/***/ }),

/***/ "HF2h":
/***/ (function(module) {

module.exports = JSON.parse("{\"co.za\":{\"live\":true,\"locales\":{\"en-ZA\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.za/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.za/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.za/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EVCS\"],\"PAYS\":\"2\",\"name\":\"South Africa\",\"LANG\":\"EN\",\"languageNativeName\":\"English\",\"moment\":\"en\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"currencies\":{\"ZAR\":{\"symbol\":\"R\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\" \",\"decimal\":\",\",\"format\":\"%s %v\"}},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"MISTER\"},{\"value\":\"MRS\",\"label\":\"MADAM\"}],\"label\":\"en\",\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"0860 258 293\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"de\":{\"live\":true,\"locales\":{\"de-DE\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.de/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.de/\",\"cmtaProdLink\":\"https://travelagents.clubmed.de/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"5\",\"LANG\":\"DE\",\"languageNativeName\":\"Deutsch\",\"label\":\"de\",\"moment\":\"de\",\"name\":[{\"name\":\"Deutschland\",\"code\":\"DE\"},{\"name\":\"Österreich\",\"code\":\"AT\"}],\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"JU\",\"label\":\"Junge\"},{\"value\":\"MA\",\"label\":\"Mädchen\"}],\"adultsCivilities\":[{\"value\":\"HR\",\"label\":\"Herr\"},{\"value\":\"FR\",\"label\":\"Frau\"}],\"currencies\":{\"EUR\":{\"symbol\":\"€\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\".\",\"decimal\":\",\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Entschuldigen Sie, unsere Webseite brauchte ein kurze Pause. Bitte probieren Sie es gleich noch einmal.\",\"phone\":\"01803 001904\",\"callUs\":\"Bitte kontaktieren Sie uns unter:\",\"travelAdvisor\":\"Ihr Club Med Berater\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"com.ar\":{\"live\":true,\"locales\":{\"es-AR\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.ar/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.ar/\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.ar/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EGLOBALCOLLECT\"],\"PAYS\":\"12\",\"LANG\":\"ES\",\"languageNativeName\":\"Español\",\"name\":[{\"name\":\"Argentina\",\"code\":\"AR\"},{\"name\":\"Uruguay\",\"code\":\"UY\"},{\"name\":\"Perù\",\"code\":\"PE\"},{\"name\":\"Bolivia\",\"code\":\"BO\"},{\"name\":\"Colombia\",\"code\":\"CO\"},{\"name\":\"Paraguay\",\"code\":\"PY\"},{\"name\":\"Venezuela\",\"code\":\"VE\"}],\"label\":\"es\",\"moment\":\"es\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"SA\",\"label\":\"Niña\"},{\"value\":\"SR\",\"label\":\"Niño\"}],\"currencies\":{\"ARS\":{\"symbol\":\"ARS\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Disculpe, nuestro sitio necesita un descanso. Por favor vuelva a intentarlo luego.\",\"phone\":\"+54(11) 4313-2006\",\"callUs\":\"Por favor, llámenos al\",\"travelAdvisor\":\"Su asesor de viaje\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"com.au\":{\"live\":true,\"locales\":{\"en-AU\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.au/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.au/\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.au/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"14\",\"LANG\":\"AE\",\"languageNativeName\":\"English\",\"name\":\"Australia\",\"label\":\"ae\",\"moment\":\"en-au\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"AUD\":{\"symbol\":\"$\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s%v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needs a quick break. Could you please check back in a moment?\",\"phone\":\"1800 258 263\",\"callUs\":\"Or if you can't wait, call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"be\":{\"live\":true,\"locales\":{\"fr-BE\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.be/\",\"cmtaStagingLink\":\"https://fr.travelagents.staging.clubmed.be/\",\"cmtaProdLink\":\"https://fr.travelagents.clubmed.be/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\",\"EHIPAY\"],\"PAYS\":\"34\",\"LANG\":\"FR\",\"languageNativeName\":\"Français\",\"label\":\"fr\",\"name\":[{\"name\":\"Belgique\",\"code\":\"BE\"},{\"name\":\"Luxembourg\",\"code\":\"LU\"}],\"moment\":\"fr\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MLLE\",\"label\":\"Fille\"},{\"value\":\"MR\",\"label\":\"Garçon\"}],\"currencies\":{\"EUR\":{\"symbol\":\"€\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\" \",\"decimal\":\",\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Veuillez nous excuser, notre site avait besoin d'une petite pause. Veuillez réessayer dans un moment.\",\"phone\":\"070 666 334\",\"callUs\":\"Contactez-nous au :\",\"travelAdvisor\":\"Votre conseiller Club Med :\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}},\"nl-BE\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.be/\",\"cmtaStagingLink\":\"https://nl.travelagents.staging.clubmed.be/\",\"cmtaProdLink\":\"https://nl.travelagents.clubmed.be/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\",\"EHIPAY\"],\"PAYS\":\"34\",\"LANG\":\"NL\",\"languageNativeName\":\"Nederlands\",\"name\":[{\"name\":\"Belgie\",\"code\":\"BE\"},{\"name\":\"Luxemburg\",\"code\":\"LU\"}],\"label\":\"nl\",\"moment\":\"nl\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MEVR\",\"label\":\"Meisje\"},{\"value\":\"MR\",\"label\":\"Jongen\"}],\"currencies\":{\"EUR\":{\"symbol\":\"€\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\" \",\"decimal\":\",\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Gelieve ons te excuseren, onze website kan momenteel niet geladen worden. Gelieve later opnieuw te proberen.\",\"phone\":\"070 666 334\",\"callUs\":\"Contacteer ons op het nummer:\",\"travelAdvisor\":\"Contacteer uw Club Med verkoopadviseur:\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"com.br\":{\"live\":true,\"locales\":{\"pt-BR\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.br/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.br/\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.br/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EGLOBALCOLLECT\"],\"PAYS\":\"42\",\"LANG\":\"PT\",\"languageNativeName\":\"Português\",\"label\":\"pt\",\"name\":\"Brasil\",\"moment\":\"pt-br\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"SA\",\"label\":\"Menina\"},{\"value\":\"SR\",\"label\":\"Menino\"}],\"currencies\":{\"BRL\":{\"symbol\":\"R$\",\"precision\":2,\"bookingPrecision\":2,\"thousand\":\".\",\"decimal\":\",\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Desculpe, nosso site está momentaneamente fora do ar. Por favor tente mais tarde.\",\"phone\":\"4002 2582\",\"callUs\":\"Por favor ligue-nos no:\",\"travelAdvisor\":\"Seu Agente Club Med\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"ca\":{\"live\":true,\"locales\":{\"en-CA\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.ca/\",\"cmtaStagingLink\":\"https://en.travelagents.staging.clubmed.ca/\",\"cmtaProdLink\":\"https://en.travelagents.clubmed.ca/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"61\",\"LANG\":\"US\",\"languageNativeName\":\"English\",\"label\":\"en\",\"name\":\"Canada\",\"moment\":\"en-ca\",\"BE\":{\"dateFormat\":\"MM/DD/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"CAD\":{\"symbol\":\"$\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s%v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"1-888-932-2582\",\"callUs\":\"Please call us at:\",\"travelAdvisor\":\"Your travel advisor:\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}},\"fr-CA\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.ca/\",\"cmtaStagingLink\":\"https://fr.travelagents.staging.clubmed.ca/\",\"cmtaProdLink\":\"https://fr.travelagents.clubmed.ca/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"61\",\"LANG\":\"CF\",\"languageNativeName\":\"Français\",\"label\":\"fr\",\"name\":\"Canada\",\"moment\":\"fr-ca\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"ME\",\"label\":\"Fille\"},{\"value\":\"M\",\"label\":\"Garçon\"}],\"currencies\":{\"CAD\":{\"symbol\":\"$\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\" \",\"decimal\":\",\",\"format\":\"%v%s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Veuillez nous excuser, notre site avait besoin d'une petite pause. Veuillez réessayer dans un moment.\",\"phone\":\"1-888-932-2582\",\"callUs\":\"Contactez-nous au :\",\"travelAdvisor\":\"Votre conseiller Club Med :\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"com.cn\":{\"live\":true,\"locales\":{\"zh-CN\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.cn/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.cn/\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.cn/\"},\"displayUnicodeFields\":true,\"enabledPaymentProviders\":[\"EALIPAY\",\"ECUP\",\"ECUPO\",\"EWECHAT\"],\"PAYS\":\"66\",\"LANG\":\"ZH\",\"languageNativeName\":\"中文\",\"label\":\"中文\",\"name\":\"中国\",\"moment\":\"zh-cn\",\"BE\":{\"dateFormat\":\"YYYY/MM/DD\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"男孩\"},{\"value\":\"MS\",\"label\":\"女孩\"}],\"currencies\":{\"CNY\":{\"symbol\":\"￥\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"不好意思，我们的网站正在升级，请稍后再回来。\",\"phone\":\"021-6197 2985\",\"callUs\":\"或拨打\",\"travelAdvisor\":\"直接联络我们的度假顾问，谢谢！\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"},\"fields\":{\"phoneNumber\":\"^[0-9]{11}$\"}},\"en-CN\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.cn/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.cn/\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.cn/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EALIPAY\",\"ECUP\",\"ECUPO\",\"EWECHAT\"],\"PAYS\":\"66\",\"LANG\":\"AE\",\"languageNativeName\":\"English\",\"label\":\"en\",\"name\":\"China\",\"moment\":\"en\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"CNY\":{\"symbol\":\"￥\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"},\"fields\":{\"phoneNumber\":\"^[0-9]{11}$\"}}}},\"co.kr\":{\"live\":true,\"locales\":{\"ko-KR\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.kr/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.kr/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.kr/\"},\"displayUnicodeFields\":true,\"enabledPaymentProviders\":[\"ECYBSSOAPI\"],\"PAYS\":\"72\",\"LANG\":\"KN\",\"languageNativeName\":\"한국어\",\"label\":\"kn\",\"moment\":\"ko\",\"name\":\"대한민국\",\"BE\":{\"dateFormat\":\"YYYY/MM/DD\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"남아\"},{\"value\":\"MS\",\"label\":\"여아\"}],\"currencies\":{\"KRW\":{\"symbol\":\"￦\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s%v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"죄송합니다. 서버 과부화로 잠시 연결이 어렵습니다. 잠시 후 다시 접속해 주세요\",\"phone\":\"02-3452-0123 (국내통화료 부과)\",\"callUs\":\"예약 상담은\",\"travelAdvisor\":\"클럽메드 전문상담원과 전화연결이 가능합니다.\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"es\":{\"live\":true,\"locales\":{\"es-ES\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.es/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.es/\",\"cmtaProdLink\":\"https://travelagents.clubmed.es/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"114\",\"LANG\":\"ES\",\"languageNativeName\":\"Español\",\"label\":\"es\",\"name\":\"España\",\"moment\":\"es\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"SRTA\",\"label\":\"Niña\"},{\"value\":\"SR\",\"label\":\"Niño\"}],\"currencies\":{\"EUR\":{\"symbol\":\"€\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\".\",\"decimal\":\",\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Lo sentimos, nuestra página no está disponible en el momento.\",\"phone\":\"902 011 211\",\"callUs\":\"Vuelva a intentarlo más tarde o llámenos al\",\"travelAdvisor\":\"Su asesor de viaje\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"us\":{\"live\":true,\"locales\":{\"en-US\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com/\",\"cmtaStagingLink\":\"https://traveladvisors.staging.clubmed.com/\",\"cmtaProdLink\":\"https://traveladvisors.clubmed.com/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"115\",\"LANG\":\"US\",\"languageNativeName\":\"English\",\"label\":\"en\",\"name\":\"U.S.A.\",\"moment\":\"en\",\"currencies\":{\"USD\":{\"symbol\":\"$\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s%v\"}},\"BE\":{\"dateFormat\":\"MM/DD/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"1-888-932-2582\",\"callUs\":\"Please call us at:\",\"travelAdvisor\":\"Your travel advisor:\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"fr\":{\"live\":true,\"locales\":{\"fr-FR\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.fr/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.fr/\",\"cmtaProdLink\":\"https://travelagents.clubmed.fr/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\",\"EHIPAY\"],\"PAYS\":\"133\",\"LANG\":\"FR\",\"languageNativeName\":\"Français\",\"label\":\"fr\",\"moment\":\"fr\",\"name\":\"France\",\"currencies\":{\"EUR\":{\"symbol\":\"€\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\".\",\"decimal\":\",\",\"format\":\"%v %s\"}},\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"ME\",\"label\":\"Fille\"},{\"value\":\"MR\",\"label\":\"Garçon\"}],\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Veuillez nous excuser, notre site avait besoin d'une petite pause. Veuillez réessayer dans un moment.\",\"phone\":\"0 810 810 810\",\"callUs\":\"Contactez-nous au\",\"travelAdvisor\":\"Votre conseiller Club Med\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"com.hk\":{\"live\":true,\"locales\":{\"en-HK\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.hk/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.hk/\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.hk/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"ECYBERSOURCE\"],\"PAYS\":\"173\",\"LANG\":\"AE\",\"languageNativeName\":\"English\",\"label\":\"en\",\"moment\":\"en\",\"name\":\"Hong-Kong\",\"currencies\":{\"HKD\":{\"symbol\":\"HKD$\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"3111 9388\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}},\"zh-HK\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.hk/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.hk/\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.hk/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[],\"PAYS\":\"173\",\"LANG\":\"ZT\",\"languageNativeName\":\"中文\",\"label\":\"中文\",\"moment\":\"zh-tw\",\"name\":\"香港\",\"currencies\":{\"HKD\":{\"symbol\":\"HKD$\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"BE\":{\"dateFormat\":\"YYYY/MM/DD\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"男孩\"},{\"value\":\"MS\",\"label\":\"女孩\"}],\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"對不起，網站現正進行更新。如有需任何協助\",\"phone\":\"3111 9388\",\"callUs\":\"請致電\",\"travelAdvisor\":\"\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"asia\":{\"live\":true,\"locales\":{\"en-IN\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.asia/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.asia/\",\"cmtaProdLink\":\"https://travelagents.clubmed.asia/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"ECYBERSOURCE\"],\"PAYS\":\"190\",\"LANG\":\"AE\",\"languageNativeName\":\"English\",\"label\":\"ae\",\"moment\":\"en\",\"name\":[{\"name\":\"India\",\"code\":\"IN\"},{\"name\":\"Afghanistan\",\"code\":\"AF\"},{\"name\":\"Bangladesh\",\"code\":\"BD\"},{\"name\":\"Brunei\",\"code\":\"BN\"},{\"name\":\"Cambodia\",\"code\":\"KH\"},{\"name\":\"Laos\",\"code\":\"LA\"},{\"name\":\"Maldives\",\"code\":\"MV\"},{\"name\":\"Myanmar\",\"code\":\"MM\"},{\"name\":\"Nepal\",\"code\":\"NP\"},{\"name\":\"Pakistan\",\"code\":\"PK\"},{\"name\":\"Philippines\",\"code\":\"PH\"},{\"name\":\"Sri Lanka\",\"code\":\"LK\"},{\"name\":\"Vietnam\",\"code\":\"VN\"}],\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"USD\":{\"symbol\":\"USD\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"022 - 400 52 180\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"co.id\":{\"live\":true,\"locales\":{\"en-ID\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.id/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.id/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.id/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"ECYBERSOURCE\"],\"PAYS\":\"191\",\"LANG\":\"AE\",\"languageNativeName\":\"English\",\"label\":\"en\",\"moment\":\"en\",\"name\":\"Indonesia\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"IDR\":{\"symbol\":\"IDR\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\" \",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"Toll Free Line 0 800 1 258 263\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}},\"id-ID\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.id/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.id/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.id/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[],\"PAYS\":\"191\",\"LANG\":\"ID\",\"languageNativeName\":\"Indonesia\",\"label\":\"id\",\"moment\":\"id\",\"name\":\"Indonesia\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MS\",\"label\":\"anak perempuan\"},{\"value\":\"MR\",\"label\":\"anak laki-laki\"}],\"currencies\":{\"IDR\":{\"symbol\":\"IDR\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\" \",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Mohon maaf situs sedang dalam perbaikan. Silahkan mencoba kembali\",\"phone\":\"0 800 1 258 263\",\"callUs\":\"Silahkan hubungi kami di :\",\"travelAdvisor\":\"Agen perjalanan Anda\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"co.il\":{\"live\":true,\"locales\":{\"he-IL\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.il/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.il/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.il/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"ENETPAY\"],\"PAYS\":\"196\",\"LANG\":\"HE\",\"languageNativeName\":\"עברית\",\"label\":\"he\",\"moment\":\"he\",\"name\":\"יִשְׂרָאֵל\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"ילדה\"},{\"value\":\"MS\",\"label\":\"נער\"}],\"direction\":\"rtl\",\"currencies\":{\"EUR\":{\"symbol\":\"€\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"אנו מתנצלים. האתר שלנו היה זקוק לחופשה קצרה. אנא נסו להיכנס בשנית.\",\"phone\":\"03-5142212\",\"callUs\":\"אתם מוזמנים ליצור איתנו קשר בטלפון\",\"travelAdvisor\":\"יועץ הנסיעות שלך\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}},\"en-IL\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.il/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.il/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.il/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"ENETPAY\"],\"PAYS\":\"196\",\"LANG\":\"EN\",\"languageNativeName\":\"English\",\"label\":\"en\",\"moment\":\"en-gb\",\"name\":\"Israel\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"direction\":\"ltr\",\"currencies\":{\"EUR\":{\"symbol\":\"€\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"03-5142212\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"it\":{\"live\":true,\"locales\":{\"it-IT\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.it/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.it/\",\"cmtaProdLink\":\"https://travelagents.clubmed.it/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"197\",\"LANG\":\"IT\",\"languageNativeName\":\"Italiano\",\"label\":\"it\",\"moment\":\"it\",\"name\":\"Italia\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"ME\",\"label\":\"Bambina\"},{\"value\":\"MR\",\"label\":\"Bambino\"}],\"currencies\":{\"EUR\":{\"symbol\":\"€\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\".\",\"decimal\":\",\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Siamo spiacenti, il nostro sito non è momentaneamente disponibile. Ti preghiamo di riprovare tra qualche minuto.\",\"phone\":\"848 800 826\",\"callUs\":\"In caso di bisogno potete contattare il numero di telefono:\",\"travelAdvisor\":\"Il tuo consulente di viaggio\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"co.jp\":{\"live\":true,\"locales\":{\"ja-JP\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.jp/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.jp/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.jp/\"},\"displayUnicodeFields\":true,\"enabledPaymentProviders\":[\"ECYBERSOURCE\"],\"PAYS\":\"206\",\"LANG\":\"JP\",\"languageNativeName\":\"日本語 (にほんご)\",\"label\":\"jp\",\"moment\":\"ja\",\"name\":\"日本\",\"BE\":{\"dateFormat\":\"YYYY/MM/DD\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"男の子\"},{\"value\":\"MS\",\"label\":\"女の子\"}],\"currencies\":{\"JPY\":{\"symbol\":\"円\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"申し訳ありません。WEBサイトで一時的なエラーが発生しました。\",\"phone\":\"0088-21-7008　IP電話・携帯電話で繫がらない場合はこちら03-5792-7627\",\"callUs\":\"お急ぎの場合はこちらのお電話にてご予約を承ります\",\"travelAdvisor\":\"東京コールセンター\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}},\"en-JP\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.jp/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.jp/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.jp/\"},\"displayUnicodeFields\":true,\"enabledPaymentProviders\":[\"ECYBERSOURCE\"],\"PAYS\":\"206\",\"LANG\":\"EN\",\"languageNativeName\":\"English\",\"label\":\"en\",\"moment\":\"en\",\"name\":\"Japan\",\"BE\":{\"dateFormat\":\"YYYY/MM/DD\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"JPY\":{\"symbol\":\"円\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needs a quick break. Could you please check back in a moment?\",\"phone\":\"0088-21-7008　IP電話・携帯電話で繫がらない場合はこちら03-5792-7627\",\"callUs\":\"Or if you can't wait, call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"com.my\":{\"live\":true,\"locales\":{\"en-MY\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.my/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.my/\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.my/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"ECYBERSOURCE\"],\"PAYS\":\"252\",\"LANG\":\"AE\",\"languageNativeName\":\"English\",\"label\":\"ae\",\"moment\":\"en\",\"name\":\"Malaysia\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"MYR\":{\"symbol\":\"MYR\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"03-2053 1888\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"com.mx\":{\"live\":true,\"locales\":{\"es-MX\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.mx/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.mx/\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.mx/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EGLOBALCOLLECT\"],\"PAYS\":\"261\",\"LANG\":\"ES\",\"languageNativeName\":\"Español\",\"label\":\"es\",\"moment\":\"es\",\"name\":\"México\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"SRTA\",\"label\":\"Niña\"},{\"value\":\"SR\",\"label\":\"Niño\"}],\"currencies\":{\"MXN\":{\"symbol\":\"MXN\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\" \",\"format\":\"%v %s\"},\"USD\":{\"symbol\":\"USD\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Lo sentimos, nuestra página no está disponible en este momento. Vuelve a intentarlo más tarde\",\"phone\":\"01 800 022 3083\",\"callUs\":\"O llámanos al\",\"travelAdvisor\":\"Su asesor de viaje\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"cl\":{\"live\":true,\"locales\":{\"es-CL\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.cl/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.cl/\",\"cmtaProdLink\":\"https://travelagents.clubmed.cl/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[],\"PAYS\":\"65\",\"LANG\":\"ES\",\"languageNativeName\":\"Español\",\"label\":\"es\",\"moment\":\"es\",\"name\":\"Chile\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"SA\",\"label\":\"Niña\"},{\"value\":\"SR\",\"label\":\"Niño\"}],\"currencies\":{\"USD\":{\"symbol\":\"USD\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Disculpe, nuestro sitio web necesita un descanso. Por favor inténtelo luego.\",\"phone\":\"188 800 551 500\",\"callUs\":\"Puede comunicarse al\",\"travelAdvisor\":\"Su asesor de viaje\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"co.nz\":{\"live\":true,\"locales\":{\"en-NZ\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.nz/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.nz/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.nz/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"ECYBERSOURCE\"],\"PAYS\":\"289\",\"LANG\":\"AE\",\"languageNativeName\":\"English\",\"label\":\"ae\",\"moment\":\"en\",\"name\":\"New Zealand\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"NZD\":{\"symbol\":\"$\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s%v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needs a quick break. Could you please check back in a moment?\",\"phone\":\"0800 258 263\",\"callUs\":\"Or if you can't wait, call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"nl\":{\"live\":true,\"locales\":{\"nl-NL\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.nl/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.nl/\",\"cmtaProdLink\":\"https://travelagents.clubmed.nl/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"314\",\"LANG\":\"NL\",\"languageNativeName\":\"Nederlands\",\"label\":\"nl\",\"moment\":\"nl\",\"name\":\"Netherlands\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Jongen\"},{\"value\":\"MS\",\"label\":\"Meisje\"}],\"currencies\":{\"EUR\":{\"symbol\":\"€\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\" \",\"decimal\":\",\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Onze excuses, onze website kan momenteel niet geladen worden. Probeer het later opniew.\",\"phone\":\"0900 202 03 06\",\"callUs\":\"Neem contact met ons op:\",\"travelAdvisor\":\"Contacteer uw Club Med verkoopadviseur:\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"pt\":{\"live\":true,\"locales\":{\"pt-PT\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.pt/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.pt/\",\"cmtaProdLink\":\"https://travelagents.clubmed.pt/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"320\",\"LANG\":\"PP\",\"languageNativeName\":\"Português\",\"label\":\"pp\",\"moment\":\"pt\",\"name\":\"Portugal\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"SRA\",\"label\":\"Menina\"},{\"value\":\"SR\",\"label\":\"Menino\"}],\"currencies\":{\"EUR\":{\"symbol\":\"€\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\" \",\"decimal\":\",\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Lamentamos mas o nosso site precisou de fazer uma pequena pausa. Por favor volte a tentar dentro de momentos.\",\"phone\":\"21 330 96 96\",\"callUs\":\"Por favor contacte-nos para\",\"travelAdvisor\":\"Seu trip advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"co.uk\":{\"live\":true,\"locales\":{\"en-GB\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.uk/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.uk/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.uk/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"341\",\"LANG\":\"EN\",\"languageNativeName\":\"English\",\"label\":\"en\",\"moment\":\"en-gb\",\"name\":[{\"name\":\"United Kingdom\",\"code\":\"GB\"},{\"name\":\"Ireland\",\"code\":\"IE\"}],\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"GBP\":{\"symbol\":\"£\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s%v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"08453 670 670\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"com.sg\":{\"live\":true,\"locales\":{\"en-SG\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.sg/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.sg/\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.sg/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"ECYBERSOURCE\"],\"PAYS\":\"362\",\"LANG\":\"AE\",\"languageNativeName\":\"English\",\"label\":\"ae\",\"moment\":\"en\",\"name\":\"Singapore\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"SGD\":{\"symbol\":\"SGD\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"1 800 258 2633\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"ch\":{\"live\":true,\"locales\":{\"fr-CH\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://fr.travelagents.integ.clubmed.ch/\",\"cmtaStagingLink\":\"https://fr.travelagents.staging.clubmed.ch/\",\"cmtaProdLink\":\"https://fr.travelagents.clubmed.ch/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\",\"EHIPAY\"],\"PAYS\":\"367\",\"LANG\":\"FR\",\"languageNativeName\":\"Français\",\"label\":\"fr\",\"moment\":\"fr\",\"name\":\"Suisse\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"ME\",\"label\":\"Fille\"},{\"value\":\"MR\",\"label\":\"Garçon\"}],\"currencies\":{\"CHF\":{\"symbol\":\"CHF\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\"\",\"decimal\":\",\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Notre site avait besoin d'une petite pause. Veuillez réessayer dans un moment.\",\"phone\":\"0844 855 966\",\"callUs\":\"Contactez-nous au :\",\"travelAdvisor\":\"Votre conseiller Club Med :\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}},\"de-CH\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://de.travelagents.integ.clubmed.ch/\",\"cmtaStagingLink\":\"https://de.travelagents.staging.clubmed.ch/\",\"cmtaProdLink\":\"https://de.travelagents.clubmed.ch/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\",\"EHIPAY\"],\"PAYS\":\"367\",\"LANG\":\"DE\",\"languageNativeName\":\"Deutsch\",\"label\":\"de\",\"moment\":\"de\",\"name\":\"Schweiz\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"FRL\",\"label\":\"Mädchen\"},{\"value\":\"HR\",\"label\":\"Junge\"}],\"currencies\":{\"CHF\":{\"symbol\":\"CHF\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\"\",\"decimal\":\",\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Unsere Seite braucht eine kurze Pause. Versuchen Sie es bitte in einem Augenblick nochmals.\",\"phone\":\"0844 855 966\",\"callUs\":\"Kontaktieren Sie uns :\",\"travelAdvisor\":\"Ihr Club Med Berater :\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}},\"en-CH\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://en.travelagents.integ.clubmed.ch/\",\"cmtaStagingLink\":\"https://en.travelagents.staging.clubmed.ch/\",\"cmtaProdLink\":\"https://en.travelagents.clubmed.ch/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\",\"EHIPAY\"],\"PAYS\":\"367\",\"LANG\":\"EN\",\"languageNativeName\":\"English\",\"label\":\"en\",\"moment\":\"en\",\"name\":\"Switzerland\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"CHF\":{\"symbol\":\"CHF\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\"\",\"decimal\":\",\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"0844 855 966\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"com.tw\":{\"live\":true,\"locales\":{\"zh-TW\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.tw/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.tw/\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.tw/\"},\"displayUnicodeFields\":true,\"enabledPaymentProviders\":[\"ECYBERSOURCE\"],\"PAYS\":\"390\",\"LANG\":\"ZT\",\"languageNativeName\":\"中華民國\",\"label\":\"zt\",\"moment\":\"zh-tw\",\"name\":\"中華民國\",\"BE\":{\"dateFormat\":\"YYYY/MM/DD\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"先生\"},{\"value\":\"MS\",\"label\":\"小姐\"}],\"currencies\":{\"TWD\":{\"symbol\":\"NT$\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s%v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"很抱歉，系統目前暫時無法處理您的需求，請稍候再嘗試，謝謝。\",\"phone\":\"0800-258-263\",\"callUs\":\"如需進一步協助，歡迎洽詢Club Med旅遊顧問：\",\"travelAdvisor\":\"Club Med 訂位客服專線\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"co.th\":{\"live\":true,\"locales\":{\"en-TH\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.th/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.th/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.th/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"ECYBERSOURCE\"],\"PAYS\":\"398\",\"LANG\":\"AE\",\"languageNativeName\":\"English\",\"label\":\"EN\",\"moment\":\"en\",\"name\":\"Thailand\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"THB\":{\"symbol\":\"฿\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\",\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"+66 (0)2 268 8448\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}},\"th-TH\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.co.th/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.co.th/\",\"cmtaProdLink\":\"https://travelagents.clubmed.co.th/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"ECYBERSOURCE\"],\"PAYS\":\"398\",\"LANG\":\"TH\",\"languageNativeName\":\"ไทย\",\"label\":\"ไทย\",\"moment\":\"th\",\"name\":\"ประเทศไทย\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"THB\":{\"symbol\":\"฿\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"+66 (0)2 268 8448\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg,https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"com.tr\":{\"live\":true,\"locales\":{\"tr-TR\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.com.tr\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.com.tr\",\"cmtaProdLink\":\"https://travelagents.clubmed.com.tr\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EIYZICO\"],\"PAYS\":\"406\",\"LANG\":\"TR\",\"languageNativeName\":\"Türkçe\",\"label\":\"tr\",\"moment\":\"tr\",\"name\":\"Türkiye\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Erkek\"},{\"value\":\"ME\",\"label\":\"Kız\"}],\"currencies\":{\"TRY\":{\"symbol\":\"TL\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Teknik bir sorun yaşandı lütfen tekrar deneyiniz.\",\"phone\":\"0212 368 09 68\",\"callUs\":\"İletişim için\",\"travelAdvisor\":\"\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"ru\":{\"live\":true,\"locales\":{\"ru-RU\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.ru/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.ru/\",\"cmtaProdLink\":\"https://travelagents.clubmed.ru/\"},\"displayUnicodeFields\":true,\"enabledPaymentProviders\":[\"ESBER\"],\"PAYS\":\"420\",\"LANG\":\"RU\",\"languageNativeName\":\"русский\",\"label\":\"ru\",\"moment\":\"ru\",\"name\":\"Россия\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Мальчик\"},{\"value\":\"MS\",\"label\":\"Девочка\"}],\"currencies\":{\"RUB\":{\"symbol\":\"руб\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%v%s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Простите, сайт уехал на курорт на каникулы, но скоро вернется!\",\"phone\":\"+7 (499) 403-0-999\",\"callUs\":\"Вы можете обратиться в наш call-центр по номеру\",\"travelAdvisor\":\"Ваш личный консультант\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"},\"nationalities\":[{\"country\":\"Австралия\",\"codeIso2\":\"AU\"},{\"country\":\"Австрия\",\"codeIso2\":\"AT\"},{\"country\":\"Азербайджан\",\"codeIso2\":\"AZ\"},{\"country\":\"Албания\",\"codeIso2\":\"AL\"},{\"country\":\"Алжир\",\"codeIso2\":\"DZ\"},{\"country\":\"Ангола\",\"codeIso2\":\"AO\"},{\"country\":\"Андорра\",\"codeIso2\":\"AD\"},{\"country\":\"Антигуа и Барбуда\",\"codeIso2\":\"AG\"},{\"country\":\"Аргентина\",\"codeIso2\":\"AR\"},{\"country\":\"Армения\",\"codeIso2\":\"AM\"},{\"country\":\"Афганистан\",\"codeIso2\":\"AF\"},{\"country\":\"Багамские Острова\",\"codeIso2\":\"BS\"},{\"country\":\"Бангладеш\",\"codeIso2\":\"BD\"},{\"country\":\"Барбадос\",\"codeIso2\":\"BB\"},{\"country\":\"Бахрейн\",\"codeIso2\":\"BH\"},{\"country\":\"Белоруссия\",\"codeIso2\":\"BY\"},{\"country\":\"Белиз\",\"codeIso2\":\"BZ\"},{\"country\":\"Бельгия\",\"codeIso2\":\"BE\"},{\"country\":\"Бенин\",\"codeIso2\":\"BJ\"},{\"country\":\"Болгария\",\"codeIso2\":\"BG\"},{\"country\":\"Боливия\",\"codeIso2\":\"BO\"},{\"country\":\"Босния и Герцеговина\",\"codeIso2\":\"BA\"},{\"country\":\"Ботсвана\",\"codeIso2\":\"BW\"},{\"country\":\"Бразилия\",\"codeIso2\":\"BR\"},{\"country\":\"Бруней\",\"codeIso2\":\"BN\"},{\"country\":\"Буркина-Фасо\",\"codeIso2\":\"BF\"},{\"country\":\"Бурунди\",\"codeIso2\":\"BI\"},{\"country\":\"Бутан\",\"codeIso2\":\"BT\"},{\"country\":\"Вануату\",\"codeIso2\":\"VU\"},{\"country\":\"Великобритания\",\"codeIso2\":\"GB\"},{\"country\":\"Венгрия\",\"codeIso2\":\"HU\"},{\"country\":\"Венесуэла\",\"codeIso2\":\"VE\"},{\"country\":\"Восточный Тимор\",\"codeIso2\":\"TL\"},{\"country\":\"Вьетнам\",\"codeIso2\":\"VN\"},{\"country\":\"Габон\",\"codeIso2\":\"GA\"},{\"country\":\"Гаити\",\"codeIso2\":\"HT\"},{\"country\":\"Гайана\",\"codeIso2\":\"GY\"},{\"country\":\"Гамбия\",\"codeIso2\":\"GM\"},{\"country\":\"Гана\",\"codeIso2\":\"GH\"},{\"country\":\"Гватемала\",\"codeIso2\":\"GT\"},{\"country\":\"Гвинея\",\"codeIso2\":\"GN\"},{\"country\":\"Гвинея-Бисау\",\"codeIso2\":\"GW\"},{\"country\":\"Германия\",\"codeIso2\":\"DE\"},{\"country\":\"Гондурас\",\"codeIso2\":\"HN\"},{\"country\":\"Гренада\",\"codeIso2\":\"GD\"},{\"country\":\"Греция\",\"codeIso2\":\"GR\"},{\"country\":\"Грузия\",\"codeIso2\":\"GE\"},{\"country\":\"Дания\",\"codeIso2\":\"DK\"},{\"country\":\"Джибути\",\"codeIso2\":\"DJ\"},{\"country\":\"Доминика\",\"codeIso2\":\"DM\"},{\"country\":\"Доминиканская Республика\",\"codeIso2\":\"DO\"},{\"country\":\"Египет\",\"codeIso2\":\"EG\"},{\"country\":\"Замбия\",\"codeIso2\":\"ZM\"},{\"country\":\"Зимбабве\",\"codeIso2\":\"ZW\"},{\"country\":\"Израиль\",\"codeIso2\":\"IL\"},{\"country\":\"Индия\",\"codeIso2\":\"IN\"},{\"country\":\"Индонезия\",\"codeIso2\":\"ID\"},{\"country\":\"Иордания\",\"codeIso2\":\"JO\"},{\"country\":\"Ирак\",\"codeIso2\":\"IQ\"},{\"country\":\"Иран\",\"codeIso2\":\"IR\"},{\"country\":\"Ирландия\",\"codeIso2\":\"IE\"},{\"country\":\"Исландия\",\"codeIso2\":\"IS\"},{\"country\":\"Испания\",\"codeIso2\":\"ES\"},{\"country\":\"Италия\",\"codeIso2\":\"IT\"},{\"country\":\"Йемен\",\"codeIso2\":\"YE\"},{\"country\":\"Кабо-Верде\",\"codeIso2\":\"CV\"},{\"country\":\"Казахстан\",\"codeIso2\":\"KZ\"},{\"country\":\"Камбоджа\",\"codeIso2\":\"KH\"},{\"country\":\"Камерун\",\"codeIso2\":\"CM\"},{\"country\":\"Канада\",\"codeIso2\":\"CA\"},{\"country\":\"Катар\",\"codeIso2\":\"QA\"},{\"country\":\"Кения\",\"codeIso2\":\"KE\"},{\"country\":\"Кипр\",\"codeIso2\":\"CY\"},{\"country\":\"Киргизия\",\"codeIso2\":\"KG\"},{\"country\":\"Кирибати\",\"codeIso2\":\"KI\"},{\"country\":\"Китай\",\"codeIso2\":\"CN\"},{\"country\":\"Колумбия\",\"codeIso2\":\"CO\"},{\"country\":\"Коморы\",\"codeIso2\":\"KM\"},{\"country\":\"Республика Конго\",\"codeIso2\":\"CG\"},{\"country\":\"Демократическая Республика Конго\",\"codeIso2\":\"CD\"},{\"country\":\"КНДР\",\"codeIso2\":\"KP\"},{\"country\":\"Республика Корея\",\"codeIso2\":\"KR\"},{\"country\":\"Коста-Рика\",\"codeIso2\":\"CR\"},{\"country\":\"Кот-д’Ивуар\",\"codeIso2\":\"CI\"},{\"country\":\"Куба\",\"codeIso2\":\"CU\"},{\"country\":\"Кувейт\",\"codeIso2\":\"KW\"},{\"country\":\"Лаос\",\"codeIso2\":\"LA\"},{\"country\":\"Латвия\",\"codeIso2\":\"LV\"},{\"country\":\"Лесото\",\"codeIso2\":\"LS\"},{\"country\":\"Либерия\",\"codeIso2\":\"LR\"},{\"country\":\"Ливан\",\"codeIso2\":\"LB\"},{\"country\":\"Ливия\",\"codeIso2\":\"LY\"},{\"country\":\"Литва\",\"codeIso2\":\"LT\"},{\"country\":\"Лихтенштейн\",\"codeIso2\":\"LI\"},{\"country\":\"Люксембург\",\"codeIso2\":\"LU\"},{\"country\":\"Маврикий\",\"codeIso2\":\"MU\"},{\"country\":\"Мавритания\",\"codeIso2\":\"MR\"},{\"country\":\"Мадагаскар\",\"codeIso2\":\"MG\"},{\"country\":\"Малави\",\"codeIso2\":\"MW\"},{\"country\":\"Малайзия\",\"codeIso2\":\"MY\"},{\"country\":\"Мали\",\"codeIso2\":\"ML\"},{\"country\":\"Мальдивы\",\"codeIso2\":\"MV\"},{\"country\":\"Мальта\",\"codeIso2\":\"MT\"},{\"country\":\"Марокко\",\"codeIso2\":\"MA\"},{\"country\":\"Маршалловы Острова\",\"codeIso2\":\"MH\"},{\"country\":\"Мексика\",\"codeIso2\":\"MX\"},{\"country\":\"Мозамбик\",\"codeIso2\":\"MZ\"},{\"country\":\"Молдавия\",\"codeIso2\":\"MD\"},{\"country\":\"Монако\",\"codeIso2\":\"MC\"},{\"country\":\"Монголия\",\"codeIso2\":\"MN\"},{\"country\":\"Мьянма\",\"codeIso2\":\"MM\"},{\"country\":\"Намибия — Республика Намибия\",\"codeIso2\":\"NA\"},{\"country\":\"Науру — Республика Науру\",\"codeIso2\":\"NR\"},{\"country\":\"Непал — Федеративная Демократическая Республика Непал\",\"codeIso2\":\"NP\"},{\"country\":\"Нигер — Республика Нигер\",\"codeIso2\":\"NE\"},{\"country\":\"Нигерия — Федеративная Республика Нигерия\",\"codeIso2\":\"NG\"},{\"country\":\"Нидерланды — Королевство Нидерландов\",\"codeIso2\":\"NL\"},{\"country\":\"Никарагуа — Республика Никарагуа\",\"codeIso2\":\"NI\"},{\"country\":\"Новая Зеландия — Новая Зеландия\",\"codeIso2\":\"NZ\"},{\"country\":\"Норвегия — Королевство Норвегия\",\"codeIso2\":\"NO\"},{\"country\":\"ОАЭ — Объединённые Арабские Эмираты\",\"codeIso2\":\"AE\"},{\"country\":\"Оман — Султанат Оман\",\"codeIso2\":\"OM\"},{\"country\":\"Пакистан — Исламская Республика Пакистан\",\"codeIso2\":\"PK\"},{\"country\":\"Палау — Республика Палау\",\"codeIso2\":\"PW\"},{\"country\":\"Панама — Республика Панама\",\"codeIso2\":\"PA\"},{\"country\":\"Папуа — Новая Гвинея — Независимое Государство Папуа — Новая Гвинея\",\"codeIso2\":\"PG\"},{\"country\":\"Парагвай — Республика Парагвай\",\"codeIso2\":\"PY\"},{\"country\":\"Перу — Республика Перу\",\"codeIso2\":\"PE\"},{\"country\":\"Польша — Республика Польша\",\"codeIso2\":\"PL\"},{\"country\":\"Португалия — Португальская Республика\",\"codeIso2\":\"PT\"},{\"country\":\"Россия — Российская Федерация\",\"codeIso2\":\"RU\"},{\"country\":\"Руанда — Республика Руанда\",\"codeIso2\":\"RW\"},{\"country\":\"Румыния — Румыния\",\"codeIso2\":\"RO\"},{\"country\":\"Сальвадор — Республика Эль-Сальвадор\",\"codeIso2\":\"SV\"},{\"country\":\"Самоа — Независимое Государство Самоа\",\"codeIso2\":\"WS\"},{\"country\":\"Сан-Марино — Республика Сан-Марино\",\"codeIso2\":\"SM\"},{\"country\":\"Сан-Томе и Принсипи — Демократическая Республика Сан-Томе и Принсипи\",\"codeIso2\":\"ST\"},{\"country\":\"Саудовская Аравия — Королевство Саудовская Аравия\",\"codeIso2\":\"SA\"},{\"country\":\"Северная Македония — Республика Северная Македония\",\"codeIso2\":\"MK\"},{\"country\":\"Сейшельские Острова — Республика Сейшельские Острова\",\"codeIso2\":\"SC\"},{\"country\":\"Сенегал — Республика Сенегал\",\"codeIso2\":\"SN\"},{\"country\":\"Сент-Винсент и Гренадины — Сент-Винсент и Гренадины\",\"codeIso2\":\"VC\"},{\"country\":\"Сент-Китс и Невис — Федерация Сент-Китс и Невис\",\"codeIso2\":\"KN\"},{\"country\":\"Сент-Люсия — Сент-Люсия\",\"codeIso2\":\"LC\"},{\"country\":\"Сербия — Республика Сербия\",\"codeIso2\":\"RS\"},{\"country\":\"Сингапур — Республика Сингапур\",\"codeIso2\":\"SG\"},{\"country\":\"Сирия — Сирийская Арабская Республика\",\"codeIso2\":\"SY\"},{\"country\":\"Словакия — Словацкая Республика\",\"codeIso2\":\"SK\"},{\"country\":\"Словения — Республика Словения\",\"codeIso2\":\"SI\"},{\"country\":\"США — Соединённые Штаты Америки\",\"codeIso2\":\"US\"},{\"country\":\"Соломоновы Острова — Соломоновы Острова\",\"codeIso2\":\"SB\"},{\"country\":\"Сомали — Федеративная Республика Сомали\",\"codeIso2\":\"SO\"},{\"country\":\"Судан — Республика Судан\",\"codeIso2\":\"SD\"},{\"country\":\"Суринам — Республика Суринам\",\"codeIso2\":\"SR\"},{\"country\":\"Сьерра-Леоне — Республика Сьерра-Леоне\",\"codeIso2\":\"SL\"},{\"country\":\"Таджикистан — Республика Таджикистан\",\"codeIso2\":\"TJ\"},{\"country\":\"Таиланд — Королевство Таиланд\",\"codeIso2\":\"TH\"},{\"country\":\"Танзания — Объединённая Республика Танзания\",\"codeIso2\":\"TZ\"},{\"country\":\"Того — Тоголезская Республика\",\"codeIso2\":\"TG\"},{\"country\":\"Тонга — Королевство Тонга\",\"codeIso2\":\"TO\"},{\"country\":\"Тринидад и Тобаго — Республика Тринидад и Тобаго\",\"codeIso2\":\"TT\"},{\"country\":\"Тувалу — Тувалу\",\"codeIso2\":\"TV\"},{\"country\":\"Тунис — Тунисская Республика\",\"codeIso2\":\"TN\"},{\"country\":\"Туркмения — Туркменистан\",\"codeIso2\":\"TM\"},{\"country\":\"Турция — Турецкая Республика\",\"codeIso2\":\"TR\"},{\"country\":\"Уганда — Республика Уганда\",\"codeIso2\":\"UG\"},{\"country\":\"Узбекистан — Республика Узбекистан\",\"codeIso2\":\"UZ\"},{\"country\":\"Украина — Украина\",\"codeIso2\":\"UA\"},{\"country\":\"Уругвай — Восточная Республика Уругвай\",\"codeIso2\":\"UY\"},{\"country\":\"Федеративные Штаты Микронезии — Федеративные Штаты Микронезии\",\"codeIso2\":\"FM\"},{\"country\":\"Фиджи — Республика Островов Фиджи\",\"codeIso2\":\"FJ\"},{\"country\":\"Филиппины — Республика Филиппины\",\"codeIso2\":\"PH\"},{\"country\":\"Финляндия — Финляндская Республика\",\"codeIso2\":\"FI\"},{\"country\":\"Франция — Французская Республика\",\"codeIso2\":\"FR\"},{\"country\":\"Хорватия — Республика Хорватия\",\"codeIso2\":\"HR\"},{\"country\":\"Центральноафриканская Республика — Центральноафриканская Республика\",\"codeIso2\":\"CF\"},{\"country\":\"Чад — Республика Чад\",\"codeIso2\":\"TD\"},{\"country\":\"Черногория — Черногория\",\"codeIso2\":\"ME\"},{\"country\":\"Чехия — Чешская Республика\",\"codeIso2\":\"CZ\"},{\"country\":\"Чили — Республика Чили\",\"codeIso2\":\"CL\"},{\"country\":\"Швейцария — Швейцарская Конфедерация\",\"codeIso2\":\"CH\"},{\"country\":\"Швеция — Королевство Швеция\",\"codeIso2\":\"SE\"},{\"country\":\"Шри-Ланка — Демократическая Социалистическая Республика Шри-Ланка\",\"codeIso2\":\"LK\"},{\"country\":\"Эквадор — Республика Эквадор\",\"codeIso2\":\"EC\"},{\"country\":\"Экваториальная Гвинея — Республика Экваториальная Гвинея\",\"codeIso2\":\"GQ\"},{\"country\":\"Эритрея — Государство Эритрея\",\"codeIso2\":\"ER\"},{\"country\":\"Эсватини — Королевство Эсватини\",\"codeIso2\":\"SZ\"},{\"country\":\"Эстония — Эстонская Республика\",\"codeIso2\":\"EE\"},{\"country\":\"Эфиопия — Федеративная Демократическая Республика Эфиопия\",\"codeIso2\":\"ET\"},{\"country\":\"ЮАР — Южно-Африканская Республика\",\"codeIso2\":\"ZA\"},{\"country\":\"Южный Судан — Республика Южный Судан\",\"codeIso2\":\"SS\"},{\"country\":\"Ямайка — Ямайка\",\"codeIso2\":\"JM\"},{\"country\":\"Япония — Япония\",\"codeIso2\":\"JP\"}]}}},\"ua\":{\"live\":true,\"locales\":{\"uk-UA\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.ua/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.ua/\",\"cmtaProdLink\":\"https://travelagents.clubmed.ua/\"},\"displayUnicodeFields\":true,\"enabledPaymentProviders\":[\"ESBER\"],\"PAYS\":\"606\",\"LANG\":\"UK\",\"languageNativeName\":\"Українська\",\"label\":\"uk\",\"moment\":\"uk\",\"name\":\"Україна\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Мальчик\"},{\"value\":\"MS\",\"label\":\"Девочка\"}],\"currencies\":{\"UAH\":{\"symbol\":\"UAH\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\".\",\"decimal\":\",\",\"format\":\"%v %s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Простите, сайт уехал на курорт на каникулы, но скоро вернется!\",\"phone\":\"+7 (499) 403-0-999\",\"callUs\":\"Вы можете обратиться в наш call-центр по номеру\",\"travelAdvisor\":\"Ваш личный консультант\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"se\":{\"live\":true,\"locales\":{\"se-SE\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.se/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.se/\",\"cmtaProdLink\":\"https://travelagents.clubmed.se/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"366\",\"LANG\":\"SE\",\"languageNativeName\":\"Svenska\",\"label\":\"se\",\"moment\":\"sv\",\"name\":[{\"name\":\"Sweden\",\"code\":\"SE\"}],\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Pojke\"},{\"value\":\"MS\",\"label\":\"Flicka\"}],\"currencies\":{\"SEK\":{\"symbol\":\"SEK\",\"precision\":0,\"bookingPrecision\":0,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%v%s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Vi ber om ursäkt, vår hemsida behövde ta en kort paus. Var vänlig testa igen om en liten stund.\",\"phone\":\"+46 850 644 364\",\"callUs\":\"Vänligen ring oss på:\",\"travelAdvisor\":\"Din reserådgivare\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"dk\":{\"live\":true,\"locales\":{\"en-DK\":{\"redirectUserSearchOnLegacy\":false,\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.dk/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.dk/\",\"cmtaProdLink\":\"https://travelagents.clubmed.dk/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\"],\"PAYS\":\"090\",\"LANG\":\"EN\",\"languageNativeName\":\"English\",\"label\":\"en\",\"moment\":\"en\",\"name\":[{\"name\":\"Denmark\",\"code\":\"DK\"},{\"name\":\"Norway\",\"code\":\"NO\"},{\"name\":\"Finland\",\"code\":\"FI\"},{\"name\":\"Ireland\",\"code\":\"IE\"}],\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"MR\",\"label\":\"Boy\"},{\"value\":\"MS\",\"label\":\"Girl\"}],\"currencies\":{\"EUR\":{\"symbol\":\"€\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%v%s\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Sorry, our website needed a quick break. Please check back in a moment.\",\"phone\":\"+46 850 644 364\",\"callUs\":\"Please call us at :\",\"travelAdvisor\":\"Your travel advisor\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"uy\":{\"live\":true,\"locales\":{\"es-UY\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.uy/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.uy/\",\"cmtaProdLink\":\"https://travelagents.clubmed.uy/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EOGONE\",\"ECYBERSOURCE\"],\"PAYS\":\"760\",\"LANG\":\"ES\",\"languageNativeName\":\"Español\",\"label\":\"es\",\"moment\":\"es\",\"name\":\"Uruguay\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"SA\",\"label\":\"Niña\"},{\"value\":\"SR\",\"label\":\"Niño\"}],\"currencies\":{\"USD\":{\"symbol\":\"USD\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Disculpe, nuestro sitio web necesita un descanso. Por favor inténtelo luego.\",\"phone\":\"0004135985579\",\"callUs\":\"Puede comunicarse al\",\"travelAdvisor\":\"Su asesor de viaje\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"lat\":{\"live\":false,\"locales\":{\"es-PA\":{\"cmtaLinks\":{\"cmtaIntegLink\":\"https://travelagents.integ.clubmed.lat/\",\"cmtaStagingLink\":\"https://travelagents.staging.clubmed.lat/\",\"cmtaProdLink\":\"https://travelagents.clubmed.lat/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[\"EGLOBALCOLLECT\"],\"PAYS\":\"019\",\"LANG\":\"ES\",\"languageNativeName\":\"Español\",\"label\":\"es\",\"moment\":\"es\",\"name\":[{\"name\":\"Panama\",\"code\":\"PA\"},{\"name\":\"Honduras\",\"code\":\"HN\"},{\"name\":\"Salvador\",\"code\":\"SV\"},{\"name\":\"Nicaragua\",\"code\":\"NI\"},{\"name\":\"Costa Rica\",\"code\":\"CR\"},{\"name\":\"Guatemala\",\"code\":\"GT\"},{\"name\":\"Puerto Rico\",\"code\":\"PR\"}],\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"SRTA\",\"label\":\"Niña\"},{\"value\":\"SR\",\"label\":\"Niño\"}],\"currencies\":{\"USD\":{\"symbol\":\"USD\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Lo sentimos, nuestra página no está disponible en este momento. Vuelve a intentarlo más tarde\",\"phone\":\"01 800 022 3083\",\"callUs\":\"O llámanos al\",\"travelAdvisor\":\"Su asesor de viaje\",\"backgroundImage\":\"https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}},\"do\":{\"live\":false,\"locales\":{\"es-DO\":{\"cmtaLinks\":{\"cmtaIntegLink\":\" https://travelagents.integ.clubmed.do/\",\"cmtaStagingLink\":\" https://travelagents.staging.clubmed.do/\",\"cmtaProdLink\":\" https://travelagents.clubmed.do/\"},\"displayUnicodeFields\":false,\"enabledPaymentProviders\":[],\"PAYS\":\"092\",\"LANG\":\"ES\",\"languageNativeName\":\"Español\",\"label\":\"es\",\"moment\":\"es\",\"name\":\"República Dominicana\",\"BE\":{\"dateFormat\":\"DD/MM/YYYY\"},\"childrenCivilities\":[{\"value\":\"SRTA\",\"label\":\"Niña\"},{\"value\":\"SR\",\"label\":\"Niño\"}],\"currencies\":{\"USD\":{\"symbol\":\"USD\",\"precision\":0,\"bookingPrecision\":2,\"thousand\":\",\",\"decimal\":\".\",\"format\":\"%s %v\"}},\"error_500\":{\"pageTitle\":\"Club Med\",\"title\":\"Lo sentimos, nuestra página no está disponible en este momento. Vuelve a intentarlo más tarde\",\"phone\":\"01 800 022 3083\",\"callUs\":\"O llámanos al\",\"travelAdvisor\":\"Su asesor de viaje\",\"backgroundImage\":\" https://ns.clubmed.com/ipm/2015/errors/CARC_D114_032_error500.jpg\"}}}}}");

/***/ }),

/***/ "Jhhs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var $padStart = __webpack_require__("uqX5").start;
var WEBKIT_BUG = __webpack_require__("2prg");

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "O5Wi":
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),

/***/ "SPKZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICONS; });
// TODO: this file is an enum dedicated to list all the icons used in the project. The utils package
// should merge all the icons lists such as:
// - packages/b2c/src/client/components/utils/icon/icons.js (this file)
// - packages/b2c-cms-config/src/schema/pages/definitions/lines/product-strengths/productStrengths.icons.js
// - packages/graphql/src/schemas/category/icons.json
var ICONS = {
  ACCESS_AGE: 'access-age',
  ACCOMODATIONS: 'accommodations',
  ACTIVITIES: 'activities',
  ADDRESS: 'address',
  ADVANCED_SKIING: 'advanced_skiing',
  ADVENTURE: 'adventure',
  ALL_INCLUSIVE: 'allInclusive',
  ANSWERS: 'answers',
  APRES_SKI: 'apres_ski',
  ARCHERY: 'archery',
  ARROW_FORTH: 'arrowForth',
  ARROW_WITH_SHADOW: 'arrowWithShadow',
  ARROW_WITH_TRAIL: 'arrowWithTrail',
  BABY_CLUB: 'babyClub',
  BADMINTON: 'badminton',
  BAGGAGE: 'baggage',
  BAR: 'barsAndRestaurants',
  BAR_CODE: 'barcode',
  BASKETBALL: 'basketball',
  BEACH: 'beach',
  BEGINNER_SPORTIVE: 'beginner-sportive',
  BIKE_RENTAL: 'bikeRental',
  BOLDER_ARROW_FORTH: 'bolderArrowForth',
  BOLDER_ARROW_FORTH_LEFT: 'bolderArrowForthLeft',
  BOLDER_ARROW_FORTH_DOWN: 'bolderArrowForthDown',
  BOLDER_ARROW_FORTH_WITH_TAIL: 'bolderArrowForthWithTail',
  BOUTIQUE: 'boutique',
  BUSINESS_CLASS: 'businessClass',
  CANCELLATION: 'cancellation',
  CAR: 'car',
  CARDIO_TRAINING: 'cardioTraining',
  CAR_PARK: 'carpark',
  CHECK: 'check',
  CHECKBOX_CHECKED: 'checkboxChecked',
  CHECKBOX_UNCHECKED: 'checkboxUnchecked',
  CHILDCARE: 'childcare',
  CHILDREN: 'children',
  CHRONO: 'chrono',
  CIRCLED_ACCOMMODATION: 'circledAccommodation',
  CIRCLED_CROSS: 'circledCross',
  CIRCLED_PLANE: 'circledPlane',
  CLIMBING: 'climbing',
  CLOSED_EYE_PASSWORD: 'closedEyePassword',
  CLUBMED: 'clubmed',
  CLUBMED_ALL_INCLUSIVE_LARGE: 'clubmedAllInclusiveLarge',
  CLUBMED_ALL_INCLUSIVE_SMALL: 'clubmedAllInclusiveSmall',
  CLUBMED_EXCLUSIVE: 'ClubMedExclusive',
  CLUBMED_EXCLUSIVE_DIGITAL: 'digital_EC',
  CLUBMED_GM: 'clubmedGM',
  CLUBMED_GM_FEEDBACK: 'ClubMedGreatMemberFeedBack',
  CLUBMED_GREAT_MEMBERS_INTRO: 'clubMedGreatMembersIntro',
  CLUBMED_GREAT_MEMBERS_GOLD: 'GreatMembersGold',
  CLUBMED_GREAT_MEMBERS_PLATINUM: 'GreatMembersPlatinum',
  CLUBMED_GREAT_MEMBERS_SILVER: 'GreatMembersSilver',
  CLUBMED_GREAT_MEMBERS_TURQUOISE: 'GreatMembersTurquoise',
  CLUBMED_GREAT_MEMBERS_WITH_SHADOW: 'GreatMembersWithShadow',
  CLUBMED_JOBS: 'clubmedJobs',
  CLUBMED_JOYVIEW: 'clubmedJoyView',
  CLUBMED_MEETINGS: 'clubmedMeetings',
  CLUBMED_PLUS: 'clubmedPlus',
  CLUBMED_PROPERTY: 'clubmedProperty',
  COMMUNITY: 'wibilongIcon',
  CONNECT: 'connect',
  COMPASS: 'compass',
  CONNECTION_INFO: 'connection-information',
  CONFIRMATION: 'confirmation',
  CONTACT: 'contact',
  COUPLE: 'couple',
  CREACTIVE: 'creactive',
  CREDIT_CARD: 'creditcard',
  CROSS: 'cross',
  CRUISE: 'cruise',
  CULTURE_DISCOVERY: 'culture-discovery',
  DANCE: 'dance',
  DATE: 'date',
  DATE_PLUS: 'datePlus',
  DATE_STAR: 'dateStar',
  DISCONNECTION: 'disconnection',
  DESTINATION: 'destination',
  DETAILS: 'details',
  DISCOVERY_CENTER: 'discovery-center',
  DISHES: 'dishes',
  DISINFECTION_BIS: 'disinfectionBis',
  DIVING: 'diving',
  DOCUMENT: 'document',
  DOCUMENT_COLORED: 'documentColored',
  DONATION: 'donation',
  DOWNLOAD: 'download',
  DRESSCODE: 'dresscode',
  DURATION: 'duration',
  EARTH: 'earth',
  EARTH_PLANE: 'earthPlane',
  EASY_ARRIVAL_TITLE: 'easyArrivalTitle',
  ESPRESSO: 'espresso',
  EXCLUSIVE_COLLECTION: 'exclusiveCollection',
  EYE_PASSWORD: 'eyePassword',
  ENTERTAINMENT: 'entertainment',
  FACEBOOK: 'facebook',
  FAT_DOT: 'fatDot',
  FAMILY: 'family',
  FITNESS: 'fitness',
  FOLDER: 'folder',
  FOOTBALL: 'football',
  GOLF: 'golf',
  GREAT_CHECK: 'greatCheck',
  HAIRDRESSER: 'hairdresser',
  HAMBURGER: 'hamburger',
  HAPPY_ARRIVAL: 'happyArrival',
  HAPPY_FIRST: 'happyFirst',
  HEALTH: 'health',
  HOME: 'home',
  ICON_45: '45',
  IDEAL_FOR_FAMILY: 'idealForFamily',
  INTERNET: 'internet',
  INFORMATION: 'information',
  INFORMATION_FILLED: 'informationFilled',
  INSURANCE: 'insurance',
  INSURANCE_CANCELLATION: 'insuranceCancellation',
  MEDICAL_ASSISTANCE: 'medicalAssistance',
  INSTAGRAM: 'instagram',
  JOYVIEW_HAND: 'flexible',
  JUNIOR: 'junior',
  KAYAK: 'kayak',
  KITESURF: 'kitesurf',
  LEFT_ARROW: 'leftArrow',
  LEISURE_AND_RELAXATION: 'leisure_and_relaxation',
  LEVEL: 'level',
  LIGHTBULB: 'lightbulb',
  LUGGAGE: 'luggage',
  MAGNIFY_GLASS: 'magnifyingGlass',
  MAIL: 'mail',
  MANAGE: 'manage',
  MAP_MINUS: 'map_minus',
  MAP_PLUS: 'map_plus',
  MAP_ROTATE_LEFT: 'map_rotate_left',
  MAP_ROTATE_RIGHT: 'map_rotate_right',
  MAXIMIZE: 'maximize',
  MEETINGS_EVENTS: 'meetingsevents',
  MINI_CLUB: 'miniClub',
  MINIMIZE: 'minimize',
  MINUS: 'minus',
  MOBILE: 'mobile',
  MOUNTAIN: 'winterMountainResorts',
  MULTIPLE_COMPANIES: 'multipleCompanies',
  MUSCULATION: 'musculation',
  MUST_TRY_EXPERIENCES: 'mustTryExperiences',
  MUST_TRY_EXPERIENCES_FR: 'mustTryExperiences-fr',
  NATURE: 'nature',
  NEW: 'new',
  NEWSLETTER: 'newsletter',
  NORDIC_WALKING: 'walking',
  NO_STOP: 'noStop',
  NO_TRANSPORT: 'noTransport',
  NOTEBOOK: 'notebook',
  ON_DEMAND: 'onDemand',
  OPTION: 'option',
  PADLOCK: 'padlock',
  PASSPORT: 'passport',
  PASSWORLD: 'passworld',
  PAYMENT_PLAN: 'paymentPlan',
  PDF: 'pdf',
  PEN: 'pen',
  PEOPLE: 'people',
  PERCENTAGE: 'percentage',
  PETANQUE: 'petanque',
  PETIT_CLUB: 'petitClub',
  PHONE: 'phone',
  PHONE_BUBBLE: 'phoneBubble',
  PHOTO_ALBUM: 'photoAlbum',
  PIN_AMENITY: 'pin_amenity',
  PIN_ROOM: 'pin_room',
  PIN_ROOM_HIGHLIGHT: 'pin_room_highlight',
  PLANE_AND_CIRCLE: 'planeAndCircle',
  PLUS: 'plus',
  PLANE: 'transport',
  PLANE_COMFORT: 'planeComfort',
  POOL_TOWELS: 'pool-towels',
  PROMO_CODE: 'promoCode',
  QUOTATION_MARK: 'quotationMark',
  QUESTION: 'question',
  RECEPTION: 'reception',
  REVERSE_CLOCK: 'reverseClock',
  RECEIPT: 'receipt',
  RIDING: 'riding',
  ROOM: 'room',
  ROOMS: 'rooms',
  RESET: 'reset',
  ROLLER: 'roller',
  SAILING: 'sailing',
  SAND_GLASS: 'sandglass',
  SEARCH_GLASS: 'searchGlass',
  SECURE_KEY: 'secureKey',
  SELECT: 'select',
  SELECT_UP: 'selectUp',
  SETTINGS: 'settings',
  SIGNOUT: 'signout',
  SIZE: 'size',
  SKI: 'ski',
  SKI_AND_POLES: 'skiAndPoles',
  SKI_IN_OUT: 'ski_in_out',
  SKI_EQUIPMENTS: 'skiEquipments',
  SMALL_CIRCLE_CHECK: 'smallCircleCheck',
  SMALL_WARNING: 'smallWarning',
  SNORKELLING: 'snorkelling',
  SNOWBOARD: 'snowboard',
  SNOWBOARD_SKIN: 'snowboardSkin',
  SPA: 'spa',
  SPECIAL_OFFERS: 'specialOffers',
  SPORT: 'sport',
  STANDALONE_MAGNIFYING_GLASS: 'StandaloneMagnifyingGlass',
  STOP_MARKER: 'stopMarker',
  SPORT_SCHOOL: 'sport_school',
  STAND_UP_PADDLE: 'stand_up_paddle',
  STORELOCATOR: 'storeLocator',
  STRAIGHT_CHECK: 'straightCheck',
  SUMMARY: 'summary',
  SUN: 'sun',
  SURF: 'surf',
  SWIM: 'swim',
  TABLE_TENNIS: 'table-tennis',
  TAKE_OFF: 'takeOff',
  TENNIS: 'tennis',
  TOOLTIP: 'tooltip',
  TOUR: 'tour',
  TRANSFER: 'transfer',
  TRANSPORT: 'transport',
  TRAPEZE: 'trapeze',
  TREETOP_ADVENTURE: 'treetop_adventure',
  TRIDENT: 'trident',
  // used as prefix,
  TRIDENT1: 'trident1',
  TRIDENT2: 'trident2',
  TRIDENT3: 'trident3',
  TRIDENT4: 'trident4',
  TRIDENT5: 'trident5',
  TRIDENT6: 'trident6',
  TRIDENT_JOYVIEW: 'tridentjoyview',
  TRAIN: 'train-transport',
  BOAT: 'boat',
  URGENTISATION: 'urgentisation',
  USER: 'user',
  USERS: 'users',
  VIDEOS: 'videos',
  VIDEOS_360: 'videos360',
  VOLLEYBALL: 'volleyball',
  VTT: 'vtt',
  WALKING: 'walking',
  WARNING: 'warning',
  WATERSKI: 'waterski',
  WECHAT: 'wechat',
  WEIGHT: 'weight',
  WELL_BEING: 'well-being',
  WHATSAPP: 'whatsapp',
  WINDSURFING: 'windsurfing',
  WINE_CELLAR: 'wineCellar',
  WINTER_MOUNTAIN: 'winterMountainResorts',
  YOGA: 'yoga',
  ZEN_ZONE: 'zenzone',
  HEART: 'heart',
  HEART_FILLED: 'heartFilled',
  SHARE: 'share',
  SHARE_LINK: 'share_link',
  SHARE_WHATSAPP: 'share_whatsapp',
  SHARE_SMS: 'share_sms',
  SHARE_MESSENGER: 'share_messenger',
  SMALL_CHECK: 'smallCheck',
  SMALL_CROSS: 'smallCross',
  // Safe Together icons
  SAFE_TOGETHER_EASY_ARRIVAL: 'stEasyArrival',
  SAFE_TOGETHER_INSURANCE: 'stInsurance',
  SAFE_TOGETHER_REDUCED_CAPACITY: 'reducedCapacity',
  SAFE_TOGETHER_DISTANCING: 'distancing',
  SAFE_TOGETHER_CAUGH: 'cough',
  SAFE_TOGETHER_APP: 'app',
  SAFE_TOGETHER_SOCIAL_DISTANCING: 'socialDistancing',
  SAFE_TOGETHER_DOCTOR: 'doctor',
  SAFE_TOGETHER_GLOVES: 'gloves',
  SAFE_TOGETHER_MASK: 'mask',
  SAFE_TOGETHER_RECEPTION_MASK: 'receptionMask',
  SAFE_TOGETHER_RESTAURANT_MASK: 'restaurantMask',
  SAFE_TOGETHER_HAND_SHAKE: 'handsShake',
  SAFE_TOGETHER_SKI_ROOM: 'skiRoom',
  SAFE_TOGETHER_SOAP: 'stSoap',
  SAFE_TOGETHER_SOLUTION: 'solution',
  SAFE_TOGETHER_SPA_MASK: 'spaMask',
  SAFE_TOGETHER_WASH: 'wash',
  SAFE_TOGETHER_DISINFECTION: 'disinfection',
  SAFE_TOGETHER_TEMPERATURE: 'temperature',
  // Accations categories
  '000017': 'dmd_club',
  '000048': 'dmd_club',
  // Club Famille Plage Vue Mer
  '000061': 'dmd_superior',
  '000018': 'dmd_deluxe',
  '000020': 'dmd_suite',
  // Deluxe Communicante Espace 5 Tridents
  '000021': 'dmd_deluxe',
  // Deluxe Espace 5 Tridents
  '000039': 'dmd_deluxe',
  // Deluxe Zen
  '000047': 'dmd_deluxe',
  // Deluxe Famille Plage Vue Mer
  '000056': 'dmd_deluxe',
  // Deluxe Exclusive
  '000019': 'dmd_suite',
  // Accommodation rooms
  SINGLE_ROOM: 'single',
  SUITE_ROOM: 'suite',
  SEPARATE_ROOMS: 'separate',
  SEPARATE_ROOMS_3: 'separate3',
  CONNECTING_ROOMS: 'connecting',
  SEPARATED_BUILDINGS: 'separated_buildings',
  SHARED_ROOM: 'shared_room',
  CONFIGURATION: 'keys',
  COMFORT: 'starlist',
  EXTRA_FEATURES: 'doorhanger',
  // Accommodation arrangements
  BABY: 'repartition-baby',
  // Accommodation strengths
  beach_side: 'beach',
  Balcony: 'balcony',
  furnished_balcony: 'balcony',
  double_balcony: 'double-balcony',
  furnished_terrace: 'furnished-terrace',
  garden_side: 'garden_side',
  lakeside: 'lakeside',
  lounge: 'lounge-area',
  lounge_area: 'lounge-area',
  poolside: 'poolside',
  private_furnished_terrace: 'private-furnished-terrace',
  private_garden: 'private-garden',
  private_pool: 'private-pool',
  sea_side: 'sea_side',
  separate_rooms: 'separate',
  separate_sleeping_area_for_the_kids: 'kids-sleeping-area',
  terrace: 'terrace',
  fir_tree_view: 'fir-tree-view',
  garden_view: 'garden_view',
  golf_view: 'golf-view',
  mountain_view_or_slopes_view: 'mountain-view',
  mountain_view: 'mountain-view',
  pool_view: 'pool-view',
  river_view: 'river-view',
  seaview: 'seaview',
  sea_view: 'sea_side',
  slopes_view: 'slopes-view',
  valley_view: 'valley-view',
  view_chailifts_or_cable_railway: 'chairlifts',
  view_of_the_grounds: 'grounds',
  view_of_the_ski_resort: 'ski-resort',
  with_balcony_or_resort_view: 'balcony',
  baby_bed: 'baby-bed',
  reduced_mobility_access: 'pmr',
  // Accommodation equipments
  MAT_000008: 'ac',
  // Climatisation
  MAT_000399: 'homecinema',
  // Home cinema
  MAT_000400: 'stereo',
  // Stereo system with speaker extensions on veranda
  typeoflodging_outside_facilities_outdoor_private_shower: 'shower',
  // Outdoor shower
  MAT_000411: 'saferoom',
  // "Safe" room reserved for the owner
  MAT_000412: 'skilocker',
  // Private ski locker at the entrance to your Chalet-Appartment
  MAT_000413: 'ventilatedlocker',
  // Ventilated locker equipped for drying ski boots
  MAT_000421: 'dvd',
  // DVD / Blu-Ray player
  MAT_000422: 'mosquitos',
  // Anti-mosquito plug
  MAT_000430: 'rainshower',
  // Shower room with rain shower
  MAT_000491: 'minifridge',
  // Minibar (in Suite only)
  MAT_000285: 'americanfridge',
  // American fridge freezer
  MAT_000280: 'lounge-area',
  // Armchair
  MAT_000407: 'electricity',
  // Asian electrical sockets (100 volts)
  MAT_000216: 'electricity',
  // Asian triple electrical plugs / 220 Volts
  MAT_000174: 'electricity',
  // Australian electrical sockets /  220-240 Volts
  MAT_000480: 'balcony',
  // Balcony
  MAT_000224: 'bathrobe',
  // Bathrobes
  MAT_000255: 'bathtubshower',
  // Bathroom (with bath and shower)
  MAT_000405: 'bathtubshower',
  // Bathroom (with bath and/or shower)
  MAT_000448: 'bathtub',
  // Bathroom with bath
  MAT_000432: 'rainshower',
  // Bathroom with bathtub and rainfall shower
  MAT_000288: 'showerdualwashbasin',
  // Bathroom with shower and two washbasins
  MAT_000306: 'showertoilets',
  // Bathroom with toilets
  MAT_000207: 'cd',
  // CD player
  MAT_000297: 'cddvd',
  // CD player/DVD player (only in the Chateau Room)
  MAT_000274: 'coffeemaker',
  // Coffee machine
  MAT_000158: 'table',
  // Coffee tables
  MAT_000286: 'kitchenware',
  // Crockery, cutlery, pans etc
  MAT_000180: 'dvd',
  // DVD player
  MAT_000428: 'bench',
  // Private daybed
  MAT_000438: 'baldaquin',
  // Sunbath daybed with canopy
  MAT_000282: 'dishwasher',
  // Dish washer
  MAT_000278: 'dressing',
  // Dressing room
  MAT_000277: 'dressingtable',
  // Dressing table
  MAT_000387: 'dualcabin',
  // Duo treatment room(s) for tandem treatments (with shower)
  MAT_000279: 'oven',
  // Electric oven
  MAT_000236: 'fan',
  // Fan
  MAT_000292: 'raclette',
  // Fondue and raclette maker
  MAT_000268: 'fridge',
  // Fridge
  MAT_000228: 'icebucket',
  // Ice bucket
  MAT_000036: 'icemaker',
  // Ice maker
  MAT_000433: 'cd',
  // In-room sound system
  MAT_000284: 'induction',
  // Induction hot plate and kitchen hood
  MAT_000211: 'internet',
  // Internet
  MAT_000301: 'ironing',
  // Ironing kit (Deluxe Room and Suite)
  MAT_000232: 'ironing',
  // Ironing kit (Deluxe Room only)
  MAT_000434: 'ironing',
  // Ironing kit (on demand)
  MAT_000435: 'ironing',
  // Ironing kit (on demande - Deluxe room only)
  typeoflodging_bathroom_facilities_japenese_bath: 'ofuro',
  // Japenese bath (Furo)
  MAT_000275: 'juicer',
  // Juicer
  MAT_000291: 'kitchen',
  // Kitchen fitted and equipped
  MAT_000266: 'ipoddock',
  // MP3 player
  MAT_000264: 'microwave',
  // Micro-wave
  MAT_000227: 'stereo',
  // Mini stereo
  MAT_000290: 'stereo',
  // Mini stereo
  MAT_000304: 'ipoddock',
  // Mini stereo and iPod/MP3 docking station
  MAT_000363: 'hammam',
  // Mixed Turkish bath
  MAT_000178: 'musicclock',
  // Radio
  MAT_000271: 'musicclock',
  // Radio / CD / MP3 player
  MAT_000014: 'musicclock',
  // Radio / CD player
  MAT_000305: 'dressing',
  // Separate dressing room
  MAT_000283: 'sheets',
  // Sheets
  MAT_000298: 'accessiblebathroom',
  // Shower room (for the Suite suitable for people with reduced mobility)
  MAT_000436: 'dualbathroom',
  // Shower room ground floor and first floor
  MAT_000299: 'showerwashbasin',
  // Shower room with shower and one washbasin
  MAT_000463: 'showerdualwashbasin',
  // Shower room with shower and two washbasins
  MAT_000406: 'showertoilets',
  // Shower room with toilets
  MAT_000270: 'electricity',
  // Swiss electrical sockets / 220 volts
  MAT_000273: 'kettle',
  // Tea and coffee kit (only in the Deluxe Rooms)
  MAT_000243: 'beachtowel',
  // Towel
  MAT_000441: 'electricity',
  // Triple electrical sockets / 230 volts
  MAT_000429: 'electricity',
  // U.S and European electrical sockets / 220 Volts
  MAT_000478: 'electricity',
  // U.S. and Brazilian electrical sockets / 110 Volts
  MAT_000173: 'electricity',
  // U.S. electrical sockets /  220 Volts
  MAT_000172: 'electricity',
  // U.S. electrical sockets / 110 Volts
  MAT_000261: 'umbrella',
  // Umbrellas
  MAT_000287: 'kitchenstorage',
  // Worktop and cupboards
  MAT_000431: 'yogamat',
  // Yoga mat
  MAT_Bluethothh_room_bathroom: 'bluetoothspeaker',
  // Bluetooth speaker in room and bathroom
  MAT_Bluetooth_room: 'bluetoothspeaker',
  // Bluetooth speaker in the room
  MAT_connected_television_: 'television',
  // Connected television (TV with international channels, VOD, radios)
  MAT_bluetooth_sound_system: 'bluetooth',
  // Bluetooth sound system
  MAT_SKINJAY: 'skinjay',
  // SKINJAY all-natural aroma shower pod system
  MAT_italian_european_sockets_220V: 'electricity',
  // Italian and European electrical sockets / 220 Volts
  MAT_tea_expresso_machine: 'espresso',
  // Tea and Expresso machine
  MAT_slippers: 'slippers',
  // Slippers
  MAT_drycleaning_service_at_extra_cost: 'pressing',
  // Drycleaning service at extra cost
  matt_showerdoublewashbasin: 'showerdualwashbasin',
  // Shower with Double Washbasin
  MAT_000469: 'electricity',
  // Brazilian and European electrical sockets / 220 Volts
  MAT_000302: 'showerbathtub',
  // Bathroom and shower room
  MAT_000294: 'kettle',
  // Tea and coffee kit
  MAT_000470: 'bluetoothspeaker',
  // Bluetooth speakers
  MAT_000276: 'separatedtoilets',
  // Separate toilets
  MAT_safe: 'safe',
  // Safe
  MAT_000259: 'showerdualwashbasin',
  // Bathroom with double washbasin
  MAT_000214: 'kettle',
  // Kettle
  MAT_000289: 'bathtubshower',
  // Bathroom with bath, shower and double washbasin
  MAT_000500: 'bathtubtoilets',
  // Bathroom with bath and toilets
  MAT_000303: 'wifi',
  // Wifi access
  MAT_000267: 'musicclock',
  // Radio alarm clock / MP3 player
  MAT_000408: 'electricity',
  // Japanese electrical sockets / 100 volts
  MAT_000223: 'television',
  // Television(s)
  MAT_television: 'television',
  // Television
  MAT_000006: 'minifridge',
  // Mini fridge at your disposal
  MAT_000005: 'phoneBubble',
  // Telephone
  MAT_000179: 'ironing',
  // Iron and ironing-board
  MAT_000171: 'electricity',
  // European electrical sockets / 220 Volts
  MAT_000004: 'safe',
  // Security safe(s)
  MAT_000213: 'musicclock',
  // Radio alarm clock / CD player
  MAT_000181: 'espresso',
  // Expresso machine
  MAT_000295: 'ironing',
  // Ironing kit
  MAT_000272: 'minifridge',
  // Minibar (Deluxe Room only)
  MAT_000293: 'minifridge',
  // Minibar
  MAT_000011: 'washingmachine',
  // Washing machine
  MAT_000501: 'bathtub',
  // Bathroom with bath and double washbasin
  MAT_000245: 'shower',
  // Shower
  MAT_000244: 'toweldryer',
  // Heated towel rail
  MAT_000012: 'dryer',
  // Tumble dryer
  MAT_000202: 'musicclock',
  // Radio alarm clock
  MAT_000002: 'hairdryer',
  // Hair dryer
  MAT_000246: 'bathtubshower',
  // Bathroom
  MAT_000260: 'bathtubshower',
  // Shower room or bathroom
  MAT_000426: 'electricity',
  // Triple British electrical sockets / 220 volts
  MST_ACT_minibar_refilled_daily: 'minifridge',
  // Mini bar refreshed daily with soft drinks
  MAT_baby_bed: 'baby-bed',
  // Baby bed
  MAT_baby_welcome_pack: 'baby-welcome',
  // Baby welcome
  MAT_AC__heating: 'ac',
  // Air condition
  MST_ACT_SERLGT_000313: 'champagne',
  // Champagne available in the private lounge
  MST_ACT_SERLGT_000330: 'shampoo',
  // Welcoming luxury products (shampoo, shower gel, cream, etc.)
  MST_ACT_SERLGT_000338: 'priorityspa',
  // Priority booking at the Club Med Spa
  MST_ACT_SERLGT_000339: 'snacks',
  // Private bar and snacking service at the caretaker's loge
  MST_ACT_SERLGT_000418: 'laundry',
  // Laundry service
  MST_ACT_SERLGT_000439: 'beachtowel',
  // Beach towel
  typeoflodging_bathroom_skinjay: 'skinjay',
  // SKINJAY all-natural aroma shower pod system
  MST_ACT_SERLGT_000323: 'slippers',
  // Slippers
  MAT_socket_type_E: 'electricity',
  // Prises électriques type E: 220 - 240 V
  MAT_sofa_couch: 'bench',
  // Canapé
  separate_living_room: 'lounge-area',
  MAT_tea_making_facilities: 'kettle',
  // Nécessaire à thé
  MST_ACT_SERLGT_000308: 'transfer',
  // Transfert pour les G.M® avec le Forfait séjour et transport
  MST_ACT_SERLGT_000321: 'luggagetransport',
  // Prise en charge des bagages en chambre
  MST_ACT_SERLGT_000327: 'bathrobe',
  // Peignoir
  MST_ACT_SERLGT_000342: 'amenities_laundry',
  // Service de nettoyage à sec (à la carte)
  MST_ACT_SERLGT_000449: 'luggagetransport',
  // Prise en charge des bagages
  MST_ACT_SERLGT_000450: 'luggagetransport',
  // Prise en charge des bagages
  typeoflodging_bathroom_facilities_hair_dryer: 'hairdryer',
  // Sèche-cheveux
  MAT_socket_type_b___100_127_v: 'electricity',
  // Prise électrique type B : 100-127 V
  MST_ACT_SERLGT_000310: 'amenities',
  // Produits d'accueil (shampoing, gel douche, crème etc.) de marque
  MST_ACT_SERLGT_000312: 'welcomegift',
  // Cadeau de bienvenue
  MST_ACT_SERLGT_000314: 'champagne',
  // Champagne à disposition dans le lounge privé (18h-23h)
  MST_ACT_SERLGT_000317: 'lunch',
  // Déjeuner offert en cas d'arrivée avant 15h
  MST_ACT_SERLGT_000328: 'people',
  // Personnel spécialement dédié
  MST_ACT_SERLGT_000329: 'swimmingpool',
  // Piscine réservée aux G.M® logés dans des Suites
  MST_ACT_SERLGT_000333: 'room-service',
  // Room service
  MST_ACT_SERLGT_000336: 'room-service',
  // Room service du petit déjeuner continental inclus
  MST_ACT_SERLGT_000416: 'beachtowel',
  // Serviette de plage
  MST_ACT_minibar_refilled_upon_request: 'minifridge',
  // Minibar
  MST_ACT_SERLGT_000440: 'minifridge',
  // Minibar (approvisionnement quotidien)
  MST_ACT_SERLGT_000454: 'room-service',
  // Room service de 7h00 à 23h00
  MST_ACT_SERLGT_butler_service: 'room-service',
  // Service de majordome
  MST_ACT_SERLGT_one_floating_breakfast: 'room-service',
  // Petit déjeuner sur plateau flottant
  MST_ACT_SERLGT_priority_specialty_restaurant: 'restaurant',
  // Réservation prioritaire au Restaurant de Spécialités
  MST_ACT_SERLGT_priority_booking_gourmet_lounge: 'dishes',
  // Réservation prioritaire au "Lounge Gourmet"
  MST_ACT_SERLGT_room_service_asian_continental_breakfast: 'room-service',
  // Room service du petit-déjeuner
  MST_PRE_003589: 'baby-welcome',
  // Club Med Baby Welcome® (4 à 23 mois)
  MST_ACT_minibar_refilled_weekly: 'minifridge',
  // Minibar (approvisionnement hebdomadaire)
  MAT_socket_type_C: 'electricity',
  // Prises électriques type C: 200 - 240 V
  MAT_universal_adaptator: 'electricity',
  // Adaptateur universel dans la chambre
  typeoflodging_bathroom_facilities_shower: 'shower',
  // Douche
  typeoflodging_bathroom_facilities_double_washbasin: 'showerdualwashbasin',
  // Double Vasque
  typeoflodging_bathroom_facilities_bathrobes: 'bathrobe',
  // Peignoir
  typeoflodging_bathroom_facilities_slippers: 'slippers',
  // Chaussons
  typeoflodging_bathroom_facilities_magnifying_mirror: 'beauty-mirror',
  // Miroir de beauté
  typeoflodging_bathroom_facilities_branded_amenities: 'amenities',
  // Produits d'accueil (shampoing, gel douche, crème etc.) de marque
  typeoflodging_outside_facilities_furnished_terrace: 'furnished-terrace',
  // Terrasse aménagée
  typeoflodging_outside_facilities_furnished_balcony: 'balcony',
  // Balcon aménagé
  typeoflodging_outside_facilities_furnished_balcony_or_terrace: 'balconyOrTerrace',
  // Balcon ou terrasse aménagé(e)
  typeoflodging_bathroom_facilities_separate_toilets: 'separatedtoilets',
  // Toilettes séparées
  MST_ACT_SERLGT_premium_wifi: 'internet',
  // Wi-Fi premium
  typeoflodging_bathroom_facilities_bath: 'bathtub',
  // Baignoire
  typeoflodging_bathroom_facilities_separate_bathroom: 'bathroom',
  // Salle de bains séparée
  typeoflodging_bathroom_facilities_accessories_amenities: 'amenities',
  // Produits d'accueil: accessoires ( bonnet de douche, vanity kit , kit manucure etc...)
  MST_PRE_003931: 'beachtowel',
  // Serviette de plage
  typeoflodging_bathroom_facilities_heated_towel_rail: 'toweldryer',
  // Sèche-serviettes
  typeoflodging_outside_facilities_balcony: 'balcony',
  // Balcon
  MST_ACT_SERLGT_ROOM: 'room-service',
  // Room service de 7h00 à 22h00
  MST_ACT_SERLGT_000322: 'luggagetransport',
  // Prise en charge des bagages en chambre
  typeoflodging_outside_facilities_private_furnished_terrace: 'furnished-terrace',
  // Terrasse privative aménagée
  MAT_socket_type_L: 'electricity',
  // Prises électriques type L: 200 - 240 V
  typeoflodging_outside_facilities_terrace_or_balcony: 'terrace',
  // Balcon ou terrasse
  MAT_socket_type_O: 'electricity',
  // Prises électriques type O: 220 - 240 V
  typeoflodging_outside_facilities_private_pool: 'private-pool',
  // Terrasse avec Piscine privative
  MST_ACT_SERLGT_000335: 'room-service',
  // Room service (à certains horaires)
  typeoflodging_outside_facilities_terrace: 'terrace',
  // Terrasse
  MAT_socket_type_I: 'electricity',
  // Prises électriques type I : 220 - 240 V
  MAT_Minibar_daily_refilled_in_the_Suite_only: 'minifridge',
  // Minibar (réapprovisionné quotidiennement dans la Suite uniquement)
  MAT_minibar_daily_refilled_in_the_deluxe: 'minifridge',
  // Minibar (approvisionnement quotidien dans la Deluxe seulement)
  typeoflodging_outside_facilities_private_garden: 'furnished-terrace',
  // Terrasse aménagée avec Jardin privatif
  MAT_air_conditioning: 'ac',
  // Air conditionné
  MST_ACT_SERLGT_laundry_service_a_la_carte: 'pressing',
  // Service de blanchisserie (à la carte)
  MAT_000157: 'daybed',
  // Transats
  MAT_000380: 'hammam',
  // Douche double hammam
  MST_ACT_ROOM_SERVICE_CONTINENTAL_JAPANESE_KOREAN_BREAKFAST: 'room-service',
  // Room service du petit-déjeuner continental, Chinese, Japanese, and Korean
  MST_ACT_champagne_manta_lounge: 'champagneglass',
  // Champagne à disposition dans le lounge privé (18h-23h)
  MST_PRE_002582: 'internet',
  // Accès Wi-Fi
  MST_ACT_SERLGT_champagne_6pm_bar: 'champagneglass',
  // Champagne servi à la flûte à 18h00 au bar
  MAT_family_room_with_curtain_between_adult_zone_kid: 'baldaquin',
  // Chambre avec  un rideau séparant la zone nuit adultes et la zone nuit enfants
  MST_ACT_SERLGT_BLUETOOTH: 'bluetoothspeaker',
  // Enceintes Bluetooth
  typeoflodging_outside_facilities_double_balcony: 'double-balcony',
  // Double Balcon
  MST_ACT_SERLGT_000311: 'waterbottle',
  // Bouteille d'eau
  MST_ACT_SERLGT_000341: 'bednight',
  // Préparation de la chambre pour la nuit
  MST_ACT_SERLGT_000483: 'household',
  // Service de ménage
  MST_ACT_SERLGT_000326: 'household',
  // Ménage fait à l'heure de votre convenance
  MST_ACT_SERLGT_000340: 'room-service',
  // Service de conciergerie
  MST_ACT_SERLGT_000324: 'household',
  // Ménage de la Suite fait à l'heure de votre convenance
  MST_ACT_SERLGT_pool_towel: 'pool-towels',
  // Serviette de piscine
  MST_ACT_SERLGT_Private_transfert_package_1: 'privateTransfer',
  MST_ACT_SERLGT_upgrade_transfer_package: 'privateTransfer',
  MST_ACT_SERLGT_covered_parking_space: 'parking',
  MST_ACT_SERLGT_mountain_diner: 'mountain-diner',
  MST_ACT_SERLGT_shuttle_service_to_the_resort: 'shuttleBus',
  fireplace: 'fireplace',
  MST_private_ski_room: 'private-ski',
  // Espace ski privé
  MST_ACT_SERLGT_000318: 'dedicated',
  // Interlocuteur dédié pour le séjour
  typeoflodging_outside_facilities_outdoor_private_bath: 'private-bathroom',
  // Bain privé extérieur sur terrasse ou balcon
  MAT_magnifying_mirror: 'beauty-mirror',
  // Miroir de beauté
  MST_ACT_SERLGT_cinq_mondes_amenities: 'amenities',
  // Produits d'accueil CINQ MONDES
  MST_ACT_SERLGT_concierge_dedicated_contact: 'room-service',
  // Service de conciergerie
  MAT_equipment_usb_socket: 'usb',
  // Prise USB
  MST_turn_down_service: 'bednight',
  // Préparation de la chambre pour la nuit
  MST_ACT_SERLGT_cleaning_on_demand: 'household',
  // Service de ménage à l'heure de votre convenance
  MST_breakfast_in_room: 'room-service',
  // Breakfast in-room
  MST_ACT_SERLGT_ROOM_SERVICE_COST: 'room-service',
  // Zimmerservice (gegen Aufpreis) von 11.00 bis 11.00 Uhr
  MST_ACT_SERLGT_room1_service_included: 'room-service',
  // Zimmerservice von 11 bis 23 Uhr
  MST_ACT_SERLGT_expresso_machine: 'espresso',
  // Expresso Machine
  MST_ACT_SERLGT_mp3_player: 'musicclock',
  // MP3 player
  // Products
  AEXC: 'aexc',
  AGAC: 'agac',
  AHSC: 'ahsc',
  ALBC: 'albc',
  ALBV: 'albv',
  ALHC: 'alhc',
  ANJJ: 'anjj',
  APLC: 'aplc',
  ARPC: 'arpc',
  AVOC: 'avoc',
  BALC: 'balc',
  BEIC: 'beic',
  BODC: 'bodc',
  BUCC: 'bucc',
  CANC: 'canc',
  CARC: 'carc',
  CERC: 'cerc',
  CFAC: 'cfac',
  CGBJ: 'cgbj',
  CHAC: 'chac',
  CHEC: 'chec',
  CM2C: 'cm2c',
  COLC: 'colc',
  CRGC: 'crgc',
  CSKC: 'cskc',
  DALC: 'dalc',
  DAOC: 'daoc',
  DBAC: 'dbac',
  DDOC: 'ddoc',
  GMAC: 'gmac',
  GMAV: 'gmav',
  GREC: 'grec',
  GRWJ: 'grwj',
  GUIC: 'guic',
  ITAC: 'itac',
  IXTC: 'ixtc',
  KABC: 'kabc',
  KAHC: 'kahc',
  KAMC: 'kamc',
  KANC: 'kanc',
  KANV: 'kanv',
  KEMC: 'kemc',
  LAPC: 'lapc',
  LPAC: 'lpac',
  LROC: 'lroc',
  MANC: 'manc',
  MAUC: 'mauc',
  MCHC: 'mchc',
  MMAC: 'mmac',
  MPAC: 'mpac',
  MPEC: 'mpec',
  NAPC: 'napc',
  OPIC: 'opic',
  PAHC: 'pahc',
  PALC: 'palc',
  PCAC: 'pcac',
  PHUC: 'phuc',
  PLAC: 'plac',
  PRAC: 'prac',
  PVAC: 'pvac',
  QCHC: 'qchc',
  RBIC: 'rbic',
  RDPC: 'rdpc',
  SAMC: 'samc',
  SANC: 'sanc',
  SAOC: 'saoc',
  SAYC: 'sayc',
  SCHC: 'schc',
  SEYC: 'seyc',
  SIBC: 'sibc',
  SMRC: 'smrc',
  TOMC: 'tomc',
  TRAC: 'trac',
  TURC: 'turc',
  TVCC: 'tvcc',
  VERC: 'verc',
  VISC: 'visc',
  VLPC: 'vlpc',
  VMOC: 'vmoc',
  VMOV: 'vmov',
  VSOC: 'vsoc',
  VTHC: 'vthc',
  YABC: 'yabc',
  YANJ: 'yanj',
  YASC: 'yasc',
  // Childcare equipments
  equipment_CHILD_blender_adapted_for_babies: 'blender',
  equipment_CHILD_microwawe_oven: 'microwave',
  equipment_CHILD_refrigerators: 'fridge',
  equipment_dishes_adapted_for_babies: 'spoon',
  equipment_CHILD_baby_body_soap: 'soap',
  equipment_CHILD_biscuits: 'biscuit',
  equipment_CHILD_bottle_warmer: 'babyBottleHeater',
  equipment_CHILD_bottle_wash_dispenser: 'soapDispenser',
  equipment_CHILD_bowls_and_containers: 'bowls',
  equipment_CHILD_brushes__cleaning_bottles_and_teats: 'bottleBrush',
  equipment_CHILD_dishwater: 'dishwasher',
  equipment_CHILD_dispenser_hand_towels: 'paperDispenser',
  equipment_CHILD_disposable_cutlery: 'disposableSilverware',
  equipment_CHILD_flat_plates_and_shallow_dishes: 'plates',
  equipment_CHILD_fruit_juice_trays: 'fruitJuice',
  equipment_CHILD_fruits_basket: 'fruitBasket',
  equipment_CHILD_long_life_semiskimmed_milk: 'skimMilk',
  equipment_CHILD_long_life_whole_milk: 'wholeMilk',
  equipment_CHILD_entier_longue_conservation: 'wholeMilk',
  equipment_CHILD_manual_fruit_press: 'manualJuicer',
  equipment_CHILD_microwawe_dishes: 'microwaveDishes',
  equipment_CHILD_mixer: 'blender',
  equipment_CHILD_plastic_or_fabric_bibs: 'bib',
  equipment_CHILD_sink: 'sink',
  equipment_CHILD_sterilisers: 'sterilizer',
  equipment_CHILD_still_water: 'waterbottle',
  equipment_CHILD_sugar_and_chocolate_powder: 'cocoaPowder',
  equipment_CHILD_wastebaskets: 'trashCan',
  equipment_CHILD_bathtub: 'bathtub',
  equipment_CHILD_changing_table: 'changingMat',
  equipment_CHILD_stroller_for_the_room_with_name_tag: 'stroller',
  equipment_CHILD_stroller_for_baby: 'stroller',
  equipment_CHILD_nappy_bin: 'trashCan',
  equipment_CHILD_lit_parapluie: 'baby-bed',
  equipment_CHILD_water_bottles: 'waterbottle',
  equipment_CHILD_baby_oil: 'oil',
  equipment_CHILD_antibacterial_soap_dispenser: 'soapDispenser',
  equipment_CHILD_Potty: 'potty',
  equipment_CHILD_baby_body_milk: 'lotion',
  equipment_CHILD_baby_powder: 'babyPowder',
  // ON DEMAND EQUIPMENTS
  BABYSITTING: 'babySitting',
  PAJAMAS: 'pajamas',
  TEENSPA: 'spa',
  SWIMMINGPOOL: 'swimmingpool',
  // OTHERS
  ALL_INCLUSIVE_WITH_SHADOW: 'allInclusiveWithShadow',
  CALLMEBACK: 'callMeBack',
  CHARMPRESTIGE: 'charmprestige',
  CIRCLED_CHECK: 'circledCheck',
  CLUBMED_ALL_INCLUSIVE_LARGE_CHINA: 'clubmedAllInclusiveLargeChina',
  CLUBMED_ALL_INCLUSIVE_SMALL_CHINA: 'clubmedAllInclusiveSmallChina',
  CLUBMED_COLLECTIVITES: 'clubmedcollectivites',
  CLUBMED_GREAT_MEMBER: 'clubmedGreatMember',
  CLUBMED_LOGO_GREAT_MEMBERS_TRADE: 'clubmedLogoGreatMembersTrade',
  DMD_STANDARD: 'dmd_standard',
  DOLLAR: 'dollar',
  DOUBAN: 'douban',
  EARLYSUN: 'earlySun',
  EASY_ARRIVAL: 'luggagetransport',
  FAQ: 'faq',
  FLEXIBLE_WITH_SHADOW: 'flexibleWithShadow',
  FLICKR: 'flickr',
  GARDEN: 'garden',
  GENTILBOT: 'gentilbot',
  GOOGLEPLUS: 'googleplus',
  INTRO_TRIDENT: 'introTrident',
  KIDS: 'kids',
  LATESUN: 'lateSun',
  LUGGAGE_TRANSPORT: 'lateSun',
  MAILREVERSE: 'mailReverse',
  MICROPHONE: 'microphone',
  MIXABLE: 'mixable',
  MOBILEAPP: 'mobileapp',
  MOON: 'moon',
  OVERFLOWINGPOOL: 'overflowingpool',
  PEOPLEBABY: 'peoplebaby',
  PINROOM: 'pinroom',
  PINROOMHIGHLIGHT: 'pinroomhighlight',
  REPARTITION_ADULT_EXP: 'repartitionAdultExp',
  REPARTITION_BABY_EXP: 'repartitionBabyExp',
  REPARTITION_CHILD_EXP: 'repartitionChildExp',
  RESORTHOUSE: 'resortHouse',
  RESORTSADULTS: 'resortsAdults',
  SEA: 'sea',
  SOCIAL: 'social',
  SPONSORSHIP: 'sponsorship',
  SPORT_LEISURE_AND_RELAXATION: 'sport_leisure_and_relaxation',
  train: 'train',
  USERTALK: 'usertalk',
  VINE: 'vine',
  VKONTAKTE: 'vkontakte',
  WECHATPAYMENT: 'wechatPayment',
  WEIBO: 'weibo',
  WELLNESS: 'wellness',
  WENC: 'wenc',
  WIFI: 'wifi',
  YOUTUBE: 'youtube'
};

/***/ }),

/***/ "TSYQ":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "UCZK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLORS; });
/* unused harmony export COLORS_LIST */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);

var COLORS = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["constants"].COLORS,
    COLORS_LIST = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["constants"].COLORS_LIST;


/***/ }),

/***/ "Yta4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("hBpG");

__webpack_require__("jQ3i");

__webpack_require__("z84I");

__webpack_require__("ho0z");

__webpack_require__("IAdD");

__webpack_require__("+KXO");

__webpack_require__("KqXw");

__webpack_require__("x4t0");

__webpack_require__("WNMA");

__webpack_require__("Jhhs");

__webpack_require__("Ysgh");

var _require = __webpack_require__("nsO7"),
    flattenDeep = _require.flattenDeep,
    get = _require.get;

var _require2 = __webpack_require__("n4CU"),
    appQueryParameters = _require2.appQueryParameters,
    windowWrapper = _require2.windowWrapper;

var FIRST_POINT_TO_END = /\.(.+)$/;
var DEFAULT_LOCALE = "fr-FR"; // TODO : Use argument (domainsService function) to avoid duplicate default locale

/*
 Naming convention :
 - "co.il" is a tld
 - "locales": { "ab-CD" : {}, "ef-GH" : {}} is a tldConfig
 - "en-US" is a locale
 - { "PAYS" : 123, "LANG" : "en", ... } is a localeConfig

 a tld has one tldConfig
 a tldConfig has many locales
 a locale has one localeConfig
 */

module.exports = function domainsService(config) {
  function lookupConfig(hostname) {
    var defaultConfig = config[hostname];
    var match = hostname.match(FIRST_POINT_TO_END);

    if (!defaultConfig && match) {
      return lookupConfig(match[1]);
    }

    if (defaultConfig) {
      defaultConfig.tld = hostname;
    }

    return defaultConfig;
  }

  function getTldForLocale(locale) {
    return Object.keys(config).find(function (k) {
      return locale in config[k].locales;
    });
  }

  function getTldConfigs() {
    return Object.keys(config);
  }

  function getLocaleForHostname(hostname) {
    return forHostname(hostname).getDefaultLocale(); // eslint-disable-line no-use-before-define
  }

  function getLocalesConfigForTldConfig(currentConfig) {
    if (currentConfig && currentConfig.locales) {
      return currentConfig.locales;
    }

    return Object.keys(config).reduce(function (acc, tld) {
      return Object.assign(acc, config[tld].locales);
    }, {});
  }

  function getLocaleConfigForLocale(locale) {
    return getLocalesConfigForTldConfig(config)[locale] || getLocalesConfigForTldConfig(config)[DEFAULT_LOCALE];
  }

  function getDirection(locale) {
    return getLocaleConfigForLocale(locale).direction;
  }

  function getBookingPrecision(locale) {
    var currencies = get(getLocaleConfigForLocale(locale), "currencies", []);
    var currency = currencies[Object.keys(currencies)[0]];
    return get(currency, "bookingPrecision", 0);
  }

  function getLocalesConfigForHostname(hostname) {
    // eslint-disable-line consistent-return
    var domainConfig = lookupConfig(hostname);

    if (domainConfig && domainConfig.locales) {
      return domainConfig;
    }
  }

  function getDefaultLocaleConfig() {
    return getLocaleConfigForLocale(DEFAULT_LOCALE);
  }

  function getIsomorphicLocaleConfig(locale) {
    return getLocaleConfigForLocale(typeof window !== "undefined" ? getLocaleForHostname(windowWrapper.getHostname()) : locale);
  }

  function getLocalesConfig() {
    var tldConfigs = Object.keys(config).map(function (tld) {
      return Object.keys(config[tld].locales).map(function (locale) {
        return Object.assign({}, config[tld].locales[locale], {
          tld: tld
        }, {
          locale: locale
        }, {
          live: config[tld].live
        });
      });
    });
    return flattenDeep(tldConfigs);
  }

  function forHostname(hostname) {
    var allLocalesForDomain = getLocalesConfigForHostname(hostname);
    var expectedLocales = allLocalesForDomain ? Object.keys(allLocalesForDomain.locales) : [DEFAULT_LOCALE];
    return {
      getAllLocales: function getAllLocales() {
        return getLocalesConfigForTldConfig(allLocalesForDomain);
      },
      getDefaultLocale: function getDefaultLocale() {
        return expectedLocales[0];
      }
    };
  }

  function isValidLocale(locale) {
    return locale && locale.match(/^[a-z]{2}-[A-Z]{2}$/) !== null;
  }

  function isLocalValidWithHostName(locale, validLocalesForHostName) {
    return Object.keys(validLocalesForHostName.getAllLocales()).includes(locale);
  }

  function forRequest(req) {
    function getRequestedLocale(validLocalesForHostName) {
      var queryLocale = get(req, "query.".concat(appQueryParameters.locale), false);

      if (isValidLocale(queryLocale)) {
        return queryLocale;
      }

      var headerLocale = get(req, "headers['accept-language']", false);
      return isValidLocale(headerLocale) && isLocalValidWithHostName(headerLocale, validLocalesForHostName) ? headerLocale : null;
    }

    var getLocale = function getLocale() {
      var validLocalesForHostName = forHostname(req.hostname);
      return getRequestedLocale(validLocalesForHostName) || validLocalesForHostName.getDefaultLocale();
    };

    return Object.assign({}, forHostname(req.hostname), {
      getRequestedLocale: getRequestedLocale,
      getLocale: getLocale
    });
  }

  function getNationalities(locale) {
    return get(getLocaleConfigForLocale(locale), "nationalities") || [];
  }

  function getDefaultLocaleForTld(tld) {
    return Object.keys(get(config[tld], "locales", {}))[0];
  }

  function shouldDisplayUnicodeFields(locale) {
    return getLocaleConfigForLocale(locale).displayUnicodeFields || null;
  }

  function getEnabledPaymentProviders(locale) {
    return (getLocaleConfigForLocale(locale) || {}).enabledPaymentProviders || [];
  }

  function getKidsCivilities(locale) {
    return get(getLocaleConfigForLocale(locale), "childrenCivilities") || [];
  }

  function getAdultsCivilities(locale) {
    return get(getLocaleConfigForLocale(locale), "adultsCivilities") || [];
  }

  function getCountryNumber(locale) {
    var countryNumber = (getLocaleConfigForLocale(locale) || {}).PAYS;
    return countryNumber.padStart(3, "0");
  }

  function getCountryLanguage(locale) {
    return (getLocaleConfigForLocale(locale) || {}).LANG;
  }

  function getCmtaLinks(locale) {
    return get(getLocaleConfigForLocale(locale), "cmtaLinks") || {};
  } // From a local, get the name of the corresponding countries (in the locale language) and the ISO
  // two letters code


  function getLocaleCountries(locale) {
    var configLocale = getLocaleConfigForLocale(locale); // Some locales correspond to several countries

    return Array.isArray(configLocale.name) ? configLocale.name : [{
      code: locale.split("-")[1],
      name: configLocale.name
    }];
  }

  return {
    DEFAULT_LOCALE: DEFAULT_LOCALE,
    getBookingPrecision: getBookingPrecision,
    getCmtaLinks: getCmtaLinks,
    getKidsCivilities: getKidsCivilities,
    getAdultsCivilities: getAdultsCivilities,
    getDomain: getLocaleConfigForLocale,
    getLocales: getLocalesConfigForHostname,
    getDefaultLocaleForTld: getDefaultLocaleForTld,
    getAllLocales: getLocalesConfigForTldConfig,
    getDefaultDomain: getDefaultLocaleConfig,
    getCurrentDomain: getIsomorphicLocaleConfig,
    getLocaleFromHostname: getLocaleForHostname,
    getDirectionFromLocale: getDirection,
    getAllTlds: getTldConfigs,
    getTldFromLocale: getTldForLocale,
    getLocalesConfig: getLocalesConfig,
    forHostname: forHostname,
    forRequest: forRequest,
    isValidLocale: isValidLocale,
    shouldDisplayUnicodeFields: shouldDisplayUnicodeFields,
    getEnabledPaymentProviders: getEnabledPaymentProviders,
    getCountryNumber: getCountryNumber,
    getCountryLanguage: getCountryLanguage,
    getLocaleCountries: getLocaleCountries,
    getNationalities: getNationalities
  };
};

/***/ }),

/***/ "g/E1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("Yta4")(__webpack_require__("HF2h"));

/***/ }),

/***/ "hNT8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("AU4o")


/***/ }),

/***/ "ovzZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__("i7Kn");
var requireObjectCoercible = __webpack_require__("cww3");

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = String(requireObjectCoercible(this));
  var result = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ "qBqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons_loaders__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("eaFI");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Icon = function Icon(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'inherit' : _ref$color,
      dataTestid = _ref.dataTestid,
      _ref$hasRtl = _ref.hasRtl,
      hasRtl = _ref$hasRtl === void 0 ? false : _ref$hasRtl,
      _ref$isNotMonoChrome = _ref.isNotMonoChrome,
      isNotMonoChrome = _ref$isNotMonoChrome === void 0 ? false : _ref$isNotMonoChrome,
      _ref$isNotSquare = _ref.isNotSquare,
      isNotSquare = _ref$isNotSquare === void 0 ? false : _ref$isNotSquare,
      name = _ref.name,
      _ref$rotation = _ref.rotation,
      rotation = _ref$rotation === void 0 ? 0 : _ref$rotation,
      style = _ref.style,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1rem' : _ref$width;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(null),
      loader = _useState[0],
      setLoader = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(100),
      ratio = _useState2[0],
      setRatio = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    if (typeof name === 'string') {
      var icon = Object(_utils_icon_icons_loaders__WEBPACK_IMPORTED_MODULE_3__[/* getLoader */ "a"])(name);

      if (icon) {
        setLoader({
          Render: icon
        });
      }
    }
  }, [name]); // We need to keep placeholder because IE 11 does not correctly scale responsive svg

  var svgRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function (node) {
    if (node !== null && isNotSquare) {
      try {
        var _node$getBBox = node.getBBox(),
            _node$getBBox$width = _node$getBBox.width,
            w = _node$getBBox$width === void 0 ? 1 : _node$getBBox$width,
            _node$getBBox$height = _node$getBBox.height,
            h = _node$getBBox$height === void 0 ? 0 : _node$getBBox$height;

        setRatio(h / w * 100);
      } catch (e) {// getBBox throw an NS_ERROR_FAILURE exception on Firefox when icon is hidden
      }
    }
  }, []);

  if (!name) {
    return null;
  }

  var styles = _objectSpread(_objectSpread({}, style), {}, {
    height: isNotSquare ? 'auto' : width,
    transform: rotation ? "rotate(".concat(rotation, "deg)") : null,
    width: width
  });

  return __jsx("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'inline-block leading-none overflow-hidden transition-all', Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
      'icon-monochrome': !isNotMonoChrome
    }, "text-".concat(color), color)),
    "data-name": name,
    "data-testid": dataTestid || 'icon',
    style: styles
  }, __jsx("span", {
    className: " block relative w-full",
    style: {
      paddingBottom: "".concat(ratio, "%")
    }
  }, loader && loader.Render && __jsx(loader.Render, {
    "aria-hidden": "true",
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('absolute fill-current h-full inset-0 w-full', {
      'rtl:-scale-x-1': hasRtl
    }),
    focusable: "false",
    xRef: svgRef
  }), alt && __jsx("span", {
    className: "sr-only"
  }, alt)));
};

/***/ }),

/***/ "uqX5":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__("tJVe");
var repeat = __webpack_require__("ovzZ");
var requireObjectCoercible = __webpack_require__("cww3");

var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = String(requireObjectCoercible($this));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = toLength(maxLength);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat.call(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

module.exports = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};


/***/ }),

/***/ "zjfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ })

}]);